'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var require$$0$3 = require('@babel/runtime/helpers/extends');
var require$$0 = require('@babel/runtime/helpers/jsx');
var require$$0$2 = require('@babel/runtime/helpers/objectSpread2');
var require$$1 = require('react');
var require$$0$1 = require('classnames');
var require$$3 = require('@andes/button');
var require$$9 = require('@andes/tooltip');
var require$$2 = require('prop-types');
var require$$8 = require('@andes/icons/Info16');
var require$$2$1 = require('@andes/typography');
var require$$4$2 = require('@andes/progress-indicator-circular');
var require$$4 = require('@andes/icons/FeedbackPositive18');
var require$$3$1 = require('@andes/bottom-sheet');
var require$$0$4 = require('frontend-image');
var require$$5 = require('@andes/carousel-snapped');
var require$$5$1 = require('@andes/carousel-free');
var require$$4$1 = require('@andes/switch');
var reviews_desktop$1 = {};
const {
  number: number$b,
  oneOfType: oneOfType$1,
  string: string$e
} = require$$2;
const PT_STARS$1 = {
  className: string$e,
  value: oneOfType$1([string$e, number$b])
};
const DF_STARS$1 = {
  className: '',
  value: 0
};
var proptypes$c = {
  PT_STARS: PT_STARS$1,
  DF_STARS: DF_STARS$1
};
var constants$3 = {};
constants$3.MAX_STARS = 5;
var _jsx$P = require$$0.default;
var _svg$3;
const namespace$y = 'ui-review-view-icon ui-review-view-icon-arrow';
const Arrow = () => _svg$3 || (_svg$3 = /*#__PURE__*/_jsx$P("svg", {
  "aria-hidden": "true",
  className: namespace$y,
  width: "66",
  height: "65",
  viewBox: "0 0 66 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, /*#__PURE__*/_jsx$P("path", {
  d: "M64.9607 32.5L1.46066 32.5",
  stroke: "#333333",
  strokeWidth: "5"
}), /*#__PURE__*/_jsx$P("path", {
  d: "M33.2106 64.25L1.46063 32.5L33.2106 0.75",
  stroke: "#333333",
  strokeWidth: "5"
})));
var arrow = Arrow;
var _jsx$O = require$$0.default;
var _path$a;
const Chevron$2 = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$O("svg", {
    className: className,
    "aria-hidden": "true",
    width: "28",
    height: "17",
    viewBox: "0 0 28 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path$a || (_path$a = /*#__PURE__*/_jsx$O("path", {
    d: "M26.086 2L13.543 14.513 1 2",
    strokeWidth: "3",
    fill: "none",
    fillRule: "evenodd"
  })));
};
Chevron$2.defaultProps = {
  className: null
};
var chevron = Chevron$2;
var _jsx$N = require$$0.default;
var _path$9;
const namespace$x = 'ui-review-view-icon ui-review-view-icon-close';
const classnames$l = require$$0$1;
const Close$2 = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$N("svg", {
    "aria-hidden": "true",
    className: classnames$l(className, namespace$x),
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path$9 || (_path$9 = /*#__PURE__*/_jsx$N("path", {
    d: "M14.9383 16L5.93834 6.99999L6.999 5.93933L15.999 14.9393L24.999 5.93933L26.0597 6.99999L17.0597 16L26.0597 25L24.999 26.0607L15.999 17.0607L6.999 26.0607L5.93834 25L14.9383 16Z",
    fill: "black"
  })));
};
var close = Close$2;
var _jsx$M = require$$0.default;
var _path$8;
/* eslint-disable max-len */
const React$r = require$$1;
const Dislike = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$M("svg", {
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, void 0, _path$8 || (_path$8 = /*#__PURE__*/_jsx$M("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28509 9.57387L5.15029 9.89771L7.77783 14.9958L8.78843 14.4746C10.1464 13.7743 10.7611 12.1653 10.2159 10.738L9.92027 9.96373L12.7198 9.92939C13.0121 9.9258 13.3012 9.86887 13.573 9.76138C14.8056 9.27393 15.4097 7.87955 14.9222 6.64695L13.6787 3.50252C12.934 1.61963 10.952 0.536042 8.96507 0.925534L5.42731 1.61902L4.18769 1.63423L4.17298 0.434452L0.0239258 0.485352L0.149047 10.6846L4.2981 10.6337L4.28509 9.57387ZM6.00474 8.93622L8.2941 13.3781C9.06982 12.9434 9.41444 12.0027 9.09492 11.1661L8.18554 8.78492L12.7051 8.72948C12.8512 8.72768 12.9958 8.69921 13.1317 8.64547C13.748 8.40175 14.05 7.70456 13.8063 7.08826L12.5628 3.94383C12.0309 2.59891 10.6152 1.82491 9.19591 2.10312L5.60462 2.8071L5.49657 2.81826L4.20241 2.83414L4.2693 8.28666L6.00474 8.93622ZM2.98762 1.64908L1.23856 1.67054L1.33424 9.46994L3.08347 9.44848L2.98762 1.64908Z",
    fill: "black",
    fillOpacity: "0.55"
  })));
};
Dislike.defaultProps = {
  className: null
};
var dislike = React$r.memo(Dislike);
var _jsx$L = require$$0.default;
var _path$7;
/* eslint-disable max-len */
const React$q = require$$1;
const DislikeDisable$1 = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$L("svg", {
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, void 0, _path$7 || (_path$7 = /*#__PURE__*/_jsx$L("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28509 9.57387L5.15029 9.89771L7.77783 14.9958L8.78843 14.4746C10.1464 13.7743 10.7611 12.1653 10.2159 10.738L9.92027 9.96373L12.7198 9.92939C13.0121 9.9258 13.3012 9.86887 13.573 9.76138C14.8056 9.27393 15.4097 7.87955 14.9222 6.64695L13.6787 3.50252C12.934 1.61963 10.952 0.536042 8.96507 0.925534L5.42731 1.61902L4.18769 1.63423L4.17298 0.434452L0.0239258 0.485352L0.149047 10.6846L4.2981 10.6337L4.28509 9.57387ZM6.00474 8.93622L8.2941 13.3781C9.06982 12.9434 9.41444 12.0027 9.09492 11.1661L8.18554 8.78492L12.7051 8.72948C12.8512 8.72768 12.9958 8.69921 13.1317 8.64547C13.748 8.40175 14.05 7.70456 13.8063 7.08826L12.5628 3.94383C12.0309 2.59891 10.6152 1.82491 9.19591 2.10312L5.60462 2.8071L5.49657 2.81826L4.20241 2.83414L4.2693 8.28666L6.00474 8.93622ZM2.98762 1.64908L1.23856 1.67054L1.33424 9.46994L3.08347 9.44848L2.98762 1.64908Z",
    fill: "black",
    fillOpacity: "0.55"
  })));
};
DislikeDisable$1.defaultProps = {
  className: null
};
var dislikeDisable = React$q.memo(DislikeDisable$1);
var _jsx$K = require$$0.default;
var _path$6, _path2$2;
/* eslint-disable max-len */
const React$p = require$$1;
const DislikeFull = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$K("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, void 0, _path$6 || (_path$6 = /*#__PURE__*/_jsx$K("path", {
    d: "M5.53083 10.0225L4.28565 9.58388L4.18818 1.63911L5.4278 1.6239L8.96556 0.930417C10.9525 0.540925 12.9345 1.62451 13.6792 3.5074L14.7491 6.20899C15.3387 7.69769 14.2539 9.31541 12.6528 9.33505L9.29453 9.37625L9.96036 11.2589C10.5153 12.828 9.6294 14.5395 8.02793 14.9925L5.53083 10.0225Z",
    fill: "white"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/_jsx$K("path", {
    d: "M2.97355 0.454055L3.09867 10.6533L0.149535 10.6895L0.0244141 0.490234L2.97355 0.454055Z",
    fill: "white"
  })));
};
DislikeFull.defaultProps = {
  className: null
};
var dislikeFull = React$p.memo(DislikeFull);
var _jsx$J = require$$0.default;
var _g;
/* eslint-disable max-len */
const React$o = require$$1;
const IconEmptyReviews = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$J("svg", {
    "aria-hidden": "true",
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "94",
    height: "79",
    viewBox: "0 0 94 79"
  }, void 0, _g || (_g = /*#__PURE__*/_jsx$J("g", {
    fill: "none",
    fillRule: "evenodd"
  }, void 0, /*#__PURE__*/_jsx$J("path", {
    fill: "#F5F5F5",
    d: "M71.227 9.707l-3.893 2 .743-4.235-3.15-3 4.353-.618L71.227 0l1.946 3.854 4.353.618-3.15 3 .744 4.235zM16.797 70.862l-2.595 1.333.496-2.824-2.1-2 2.902-.412 1.297-2.569 1.298 2.57 2.902.411-2.1 2 .496 2.824zM51.603 72.17l-1.946 1 .371-2.117-1.574-1.5 2.176-.309.973-1.927.973 1.927 2.177.309-1.575 1.5.372 2.118z"
  }), /*#__PURE__*/_jsx$J("path", {
    fill: "#E9E9E9",
    d: "M72.134 76.011l-2.91-.152 1.832-2.196-.825-2.789 2.717 1.104 2.4-1.571-.152 2.878 2.308 1.817-2.811.675-.974 2.695zM89.478 30.862l-2.596 1.333.496-2.824-2.1-2 2.902-.412 1.298-2.569 1.297 2.57 2.902.411-2.1 2 .496 2.824zM27.471 7.745L26.314 9.61l-.764-2.008-2.117-.47 1.707-1.392-.152-2.157 1.82 1.147 2.024-.863-.583 2.102 1.402 1.623zM6.299 43.854l-3.893 2 .743-4.236-3.149-3L4.352 38 6.3 34.146 8.245 38l4.353.618-3.15 3 .744 4.236z"
  }), /*#__PURE__*/_jsx$J("path", {
    d: "M47.762 52.155L32.02 60.488l3.006-17.65L22.29 30.34l17.601-2.575 7.872-16.058 7.872 16.058 17.602 2.575-12.737 12.499 3.007 17.649z"
  }), /*#__PURE__*/_jsx$J("path", {
    fill: "#D3D3D3",
    d: "M56.206 40.738l11.792-11.27 5.31.707-12.737 12.5 3.007 17.648-4.539-2.402z"
  }), /*#__PURE__*/_jsx$J("path", {
    stroke: "#8B8B8B",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M47.762 52.155L32.02 60.488l3.006-17.65L22.29 30.34l17.601-2.575 7.872-16.058 7.872 16.058 17.602 2.575-12.737 12.499 3.007 17.649z"
  }), /*#__PURE__*/_jsx$J("g", {
    fill: "#8B8B8B",
    transform: "translate(40.701 32.195)"
  }, void 0, /*#__PURE__*/_jsx$J("ellipse", {
    cx: "1.938",
    cy: "1.951",
    rx: "1.938",
    ry: "1.951"
  }), /*#__PURE__*/_jsx$J("ellipse", {
    cx: "12.598",
    cy: "1.951",
    rx: "1.938",
    ry: "1.951"
  })))));
};
IconEmptyReviews.defaultProps = {
  className: ''
};
var emptyReviews = React$o.memo(IconEmptyReviews);
var _jsx$I = require$$0.default;
var _svg$2;
const namespace$w = 'ui-review-view-icon ui-review-view-icon-filter';
const FilterIcon$2 = () => _svg$2 || (_svg$2 = /*#__PURE__*/_jsx$I("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: namespace$w
}, void 0, /*#__PURE__*/_jsx$I("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1999 4.64098H13.2334C13.0111 3.54562 12.0427 2.72119 10.8817 2.72119C9.72069 2.72119 8.75227 3.54562 8.5299 4.64098H0.799858V5.60098H8.5299C8.75227 6.69633 9.72069 7.52076 10.8817 7.52076C12.0427 7.52076 13.0111 6.69633 13.2334 5.60098H15.1999V4.64098ZM9.44189 5.12098C9.44189 5.91615 10.0865 6.56076 10.8817 6.56076C11.6768 6.56076 12.3215 5.91615 12.3215 5.12098C12.3215 4.32581 11.6768 3.68119 10.8817 3.68119C10.0865 3.68119 9.44189 4.32581 9.44189 5.12098Z",
  fill: "#3483FA"
}), /*#__PURE__*/_jsx$I("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.76786 11.3603L0.799805 11.3601L0.799905 10.4001L2.76788 10.4003C2.99026 9.30496 3.95867 8.48055 5.11964 8.48055C6.28062 8.48055 7.24905 9.30498 7.47142 10.4003H15.2799V11.3603H7.47142C7.24905 12.4557 6.28062 13.2801 5.11964 13.2801C3.95865 13.2801 2.99022 12.4557 2.76786 11.3603ZM5.11964 12.3201C4.32447 12.3201 3.67986 11.6755 3.67986 10.8803C3.67986 10.0852 4.32447 9.44055 5.11964 9.44055C5.91482 9.44055 6.55943 10.0852 6.55943 10.8803C6.55943 11.6755 5.91482 12.3201 5.11964 12.3201Z",
  fill: "#3483FA"
})));
var filterIcon = FilterIcon$2;
var _jsx$H = require$$0.default;
var _svg$1;
const Flag = () => _svg$1 || (_svg$1 = /*#__PURE__*/_jsx$H("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, /*#__PURE__*/_jsx$H("path", {
  d: "M3.33301 3.33496V14.0016",
  stroke: "black",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_jsx$H("path", {
  d: "M12.668 3.33496V9.33496",
  stroke: "black",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_jsx$H("path", {
  d: "M3.33301 3.33469C3.9561 2.72394 4.79383 2.38184 5.66634 2.38184C6.53885 2.38184 7.37658 2.72394 7.99968 3.33469C8.62277 3.94545 9.4605 4.28755 10.333 4.28755C11.2055 4.28755 12.0432 3.94545 12.6663 3.33469",
  stroke: "black",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_jsx$H("path", {
  d: "M3.33301 9.33469C3.9561 8.72394 4.79383 8.38184 5.66634 8.38184C6.53885 8.38184 7.37658 8.72394 7.99968 9.33469C8.62277 9.94545 9.4605 10.2876 10.333 10.2876C11.2055 10.2876 12.0432 9.94545 12.6663 9.33469",
  stroke: "black",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
var flag = Flag;
var _jsx$G = require$$0.default;
var _svg;
const namespace$v = 'ui-review-capability-icon ui-review-capability-icon-info';
const Info$2 = () => _svg || (_svg = /*#__PURE__*/_jsx$G("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: namespace$v
}, void 0, /*#__PURE__*/_jsx$G("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8003 7.9999C15.8003 12.3078 12.3081 15.8 8.00026 15.8C3.6924 15.8 0.200195 12.3078 0.200195 7.9999C0.200195 3.69204 3.6924 0.199829 8.00026 0.199829C12.3081 0.199829 15.8003 3.69204 15.8003 7.9999ZM10.3951 11.1445V12.1445H5.93701V11.1445H7.40556V7.42649H6.29522V6.42649H8.86389V11.1445H10.3951ZM8.88013 4.58104C8.88013 5.05624 8.49491 5.44146 8.01971 5.44146C7.54452 5.44146 7.1593 5.05624 7.1593 4.58104C7.1593 4.10585 7.54452 3.72063 8.01971 3.72063C8.49491 3.72063 8.88013 4.10585 8.88013 4.58104ZM1.4002 7.9999C1.4002 11.645 4.35515 14.6 8.00026 14.6C11.6454 14.6 14.6003 11.645 14.6003 7.9999C14.6003 4.35478 11.6454 1.39983 8.00026 1.39983C4.35515 1.39983 1.4002 4.35478 1.4002 7.9999Z",
  fill: "black"
})));
var info = Info$2;
var _jsx$F = require$$0.default;
var _path$5;
/* eslint-disable max-len */
const React$n = require$$1;
const Like = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$F("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, void 0, _path$5 || (_path$5 = /*#__PURE__*/_jsx$F("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02125 6.25775L5.87824 5.91279L8.37994 0.751802L9.40301 1.24803C10.7777 1.91481 11.4317 3.50825 10.9218 4.94852L10.6452 5.72977L13.4447 5.69542C13.737 5.69184 14.0274 5.74166 14.3018 5.84245C15.546 6.29952 16.184 7.67866 15.727 8.92284L14.5609 12.0968C13.8627 13.9974 11.9079 15.1293 9.91198 14.7887L6.35827 14.1822L5.11866 14.1974L5.13337 15.3972L0.984325 15.4481L0.859204 5.24885L5.00825 5.19795L5.02125 6.25775ZM6.75603 6.85303L8.93573 2.3563C9.72188 2.77187 10.0895 3.7038 9.79057 4.54802L8.93988 6.95078L13.4594 6.89533C13.6056 6.89354 13.7508 6.91845 13.888 6.96885C14.5101 7.19738 14.8291 7.88695 14.6006 8.50904L13.4345 11.683C12.9358 13.0406 11.5395 13.8491 10.1139 13.6058L6.50639 12.9901L6.39809 12.9816L5.10394 12.9975L5.03705 7.54496L6.75603 6.85303ZM3.91858 14.212L2.16951 14.2334L2.07383 6.43404L3.82306 6.41258L3.91858 14.212Z",
    fill: "black",
    fillOpacity: "0.55"
  })));
};
Like.defaultProps = {
  className: null
};
var like = React$n.memo(Like);
var _jsx$E = require$$0.default;
var _path$4;
/* eslint-disable max-len */
const React$m = require$$1;
const LikeDisable$1 = className => /*#__PURE__*/_jsx$E("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: className
}, void 0, _path$4 || (_path$4 = /*#__PURE__*/_jsx$E("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.02125 6.25775L5.87824 5.91279L8.37994 0.751802L9.40301 1.24803C10.7777 1.91481 11.4317 3.50825 10.9218 4.94852L10.6452 5.72977L13.4447 5.69542C13.737 5.69184 14.0274 5.74166 14.3018 5.84245C15.546 6.29952 16.184 7.67866 15.727 8.92284L14.5609 12.0968C13.8627 13.9974 11.9079 15.1293 9.91198 14.7887L6.35827 14.1822L5.11866 14.1974L5.13337 15.3972L0.984325 15.4481L0.859204 5.24885L5.00825 5.19795L5.02125 6.25775ZM6.75603 6.85303L8.93573 2.3563C9.72188 2.77187 10.0895 3.7038 9.79057 4.54802L8.93988 6.95078L13.4594 6.89533C13.6056 6.89354 13.7508 6.91845 13.888 6.96885C14.5101 7.19738 14.8291 7.88695 14.6006 8.50904L13.4345 11.683C12.9358 13.0406 11.5395 13.8491 10.1139 13.6058L6.50639 12.9901L6.39809 12.9816L5.10394 12.9975L5.03705 7.54496L6.75603 6.85303ZM3.91858 14.212L2.16951 14.2334L2.07383 6.43404L3.82306 6.41258L3.91858 14.212Z",
  fill: "black",
  fillOpacity: "0.55"
})));
LikeDisable$1.defaultProps = {
  className: null
};
var likeDisable = React$m.memo(LikeDisable$1);
var _jsx$D = require$$0.default;
var _path$3, _path2$1;
/* eslint-disable max-len */
const React$l = require$$1;
const LikeFull = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$D("svg", {
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, void 0, _path$3 || (_path$3 = /*#__PURE__*/_jsx$D("path", {
    d: "M6.25811 5.07832L5.02406 5.54732L5.12152 13.4921L6.36114 13.4769L9.91485 14.0834C11.9108 14.424 13.8656 13.2921 14.5638 11.3915L15.5672 8.6645C16.1201 7.16179 14.9959 5.57117 13.3948 5.59081L10.0365 5.63201L10.656 3.73357C11.1722 2.15138 10.2446 0.462057 8.63253 0.0485436L6.25811 5.07832Z",
    fill: "none"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/_jsx$D("path", {
    d: "M3.93633 14.7066L3.81121 4.50736L0.862071 4.54354L0.987192 14.7428L3.93633 14.7066Z",
    fill: "none"
  })));
};
LikeFull.defaultProps = {
  className: null
};
var likeFull = React$l.memo(LikeFull);
var _jsx$C = require$$0.default;
var _use$2;
const React$k = require$$1;
const IconStarEmpty$2 = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$C("svg", {
    "aria-hidden": "true",
    className: className,
    width: "16.8",
    height: "16",
    viewBox: "0 0 11 10"
  }, void 0, _use$2 || (_use$2 = /*#__PURE__*/_jsx$C("use", {
    href: "#poly_star"
  })));
};
IconStarEmpty$2.defaultProps = {
  className: ''
};
var starEmpty = React$k.memo(IconStarEmpty$2);
var _jsx$B = require$$0.default;
var _use$1;
const React$j = require$$1;
const IconStarFull = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$B("svg", {
    className: className,
    "aria-hidden": "true",
    width: "16.8",
    height: "16",
    viewBox: "0 0 10 10"
  }, void 0, _use$1 || (_use$1 = /*#__PURE__*/_jsx$B("use", {
    href: "#poly_star_fill"
  })));
};
IconStarFull.defaultProps = {
  className: ''
};
var starFull = React$j.memo(IconStarFull);
var _jsx$A = require$$0.default;
var _use;
const React$i = require$$1;
const IconStarHalf = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$A("svg", {
    "aria-hidden": "true",
    className: className,
    width: "16.8",
    height: "16",
    viewBox: "0 0 10 10"
  }, void 0, _use || (_use = /*#__PURE__*/_jsx$A("use", {
    href: "#poly_star_half"
  })));
};
IconStarHalf.defaultProps = {
  className: ''
};
var starHalf = React$i.memo(IconStarHalf);
var _jsx$z = require$$0.default;
var _path$2, _path2, _path3, _path4;
const React$h = require$$1;
const classnames$k = require$$0$1;
const namespace$u = 'ui-reviews-icon ui-reviews-icon--empty-messages';
const EmptyMessage$1 = _ref => {
  let {
    className,
    aria_hidden
  } = _ref;
  return /*#__PURE__*/_jsx$z("svg", {
    className: classnames$k(namespace$u, className),
    width: "143",
    height: "94",
    viewBox: "0 0 143 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": aria_hidden
  }, void 0, _path$2 || (_path$2 = /*#__PURE__*/_jsx$z("path", {
    d: "M98.8956 20.9082V20.9082C98.8955 19.5947 97.8133 18.5 96.4414 18.5H46.561C45.189 18.5 44.1068 19.5947 44.1068 20.9082V61.1928C44.1068 62.5063 45.189 63.601 46.561 63.601H74.1231H74.5324L74.8849 63.8088L89.8613 72.638V65.101V63.601L91.3613 63.601L96.4423 63.601C97.8143 63.601 98.8965 62.5063 98.8965 61.1928L98.8956 20.9082Z",
    fill: "#EEEEEE",
    stroke: "white",
    strokeWidth: "3"
  })), _path2 || (_path2 = /*#__PURE__*/_jsx$z("path", {
    d: "M42.6068 37V61.1928C42.6068 63.3512 44.3771 65.101 46.561 65.101H74.1231L91.3613 75.2636V65.101L96.4423 65.101C98.6262 65.101 100.396 63.3512 100.396 61.1927L100.396 57M42.6068 33V20.9082C42.6068 18.7498 44.3771 17 46.561 17H96.4414C98.6252 17 100.396 18.7498 100.396 20.9082V46M100.396 50V53",
    stroke: "#333333",
    strokeWidth: "1.5"
  })), _path3 || (_path3 = /*#__PURE__*/_jsx$z("path", {
    d: "M72.4785 46.1044L71.8267 45.7899L71.1748 46.1044L66.9459 48.1449L67.7189 44.0086L67.874 43.1783L67.2445 42.6151L64.0921 39.7949L68.5749 39.1971L69.3347 39.0957L69.6977 38.4206L71.8267 34.4616L73.9556 38.4206L74.3186 39.0957L75.0784 39.1971L79.5613 39.7949L76.4088 42.6151L75.7793 43.1783L75.9345 44.0086L76.7075 48.1449L72.4785 46.1044Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "3"
  })), _path4 || (_path4 = /*#__PURE__*/_jsx$z("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8267 47.4553L64.9266 50.7847L66.2444 43.733L60.6621 38.739L68.3766 37.7102L71.8267 31.2944L75.2767 37.7102L82.9912 38.739L77.409 43.733L78.7268 50.7847L71.8267 47.4553Z",
    stroke: "#333333",
    strokeWidth: "1.5"
  })));
};
EmptyMessage$1.defaultProps = {
  className: null,
  aria_hidden: true
};
var emptyMessages$1 = React$h.memo(EmptyMessage$1);
const ArrowIcon = arrow;
const ChevronIcon = chevron;
const CloseIcon = close;
const DislikeIcon$1 = dislike;
const DislikeDisableIcon = dislikeDisable;
const DislikeFullIcon$1 = dislikeFull;
const EmptyReviewsIcon = emptyReviews;
const FilterIcon$1 = filterIcon;
const FlagIcon$1 = flag;
const InfoIcon = info;
const LikeIcon$1 = like;
const LikeDisableIcon = likeDisable;
const LikeFullIcon$1 = likeFull;
const StarEmptyIcon$3 = starEmpty;
const StarFullIcon$1 = starFull;
const StarHalfIcon$1 = starHalf;
const EmptyMessage = emptyMessages$1;
var icons$1 = {
  ArrowIcon,
  ChevronIcon,
  CloseIcon,
  DislikeIcon: DislikeIcon$1,
  DislikeDisableIcon,
  DislikeFullIcon: DislikeFullIcon$1,
  EmptyReviewsIcon,
  FilterIcon: FilterIcon$1,
  FlagIcon: FlagIcon$1,
  InfoIcon,
  LikeIcon: LikeIcon$1,
  LikeDisableIcon,
  LikeFullIcon: LikeFullIcon$1,
  StarEmptyIcon: StarEmptyIcon$3,
  StarFullIcon: StarFullIcon$1,
  StarHalfIcon: StarHalfIcon$1,
  EmptyMessage
};
const {
  StarEmptyIcon: StarEmptyIcon$2,
  StarFullIcon,
  StarHalfIcon
} = icons$1;
const starIconsSources$1 = {
  FULL: StarFullIcon,
  HALF: StarHalfIcon,
  EMPTY: StarEmptyIcon$2
};
var sourcesStars = starIconsSources$1;
const getStars$1 = (value, maxStars) => {
  const FULL_STARS_QUANTITY = Math.floor(value);
  const FULL_STARS = Array(FULL_STARS_QUANTITY).fill('FULL');
  const HALF_STARS_QUANTITY = Math.ceil(value - FULL_STARS_QUANTITY);
  const HALF_STARS = Array(HALF_STARS_QUANTITY).fill('HALF');
  const EMPTY_STARS_QUANTITY = maxStars - HALF_STARS_QUANTITY - FULL_STARS_QUANTITY;
  const EMPTY_STARS = EMPTY_STARS_QUANTITY > 0 ? Array(EMPTY_STARS_QUANTITY).fill('EMPTY') : [];
  const STARS_QUANTITY_ARR = [FULL_STARS_QUANTITY, HALF_STARS_QUANTITY, EMPTY_STARS_QUANTITY];
  const STARS_QUANTITY = STARS_QUANTITY_ARR.reduce((acc, val) => acc + val, 0);
  const STARS = [...FULL_STARS, ...HALF_STARS, ...EMPTY_STARS].slice(0, maxStars);
  return {
    STARS,
    STARS_QUANTITY,
    FULL_STARS_QUANTITY,
    HALF_STARS_QUANTITY,
    EMPTY_STARS_QUANTITY
  };
};
var getStars_1 = getStars$1;
var _objectSpread$q = require$$0$2.default;
var _jsx$y = require$$0.default;
/* eslint-disable jsx-a11y/label-has-associated-control */
const React$g = require$$1;
const classNames$3 = require$$0$1;
const {
  PT_STARS,
  DF_STARS
} = proptypes$c;
const {
  MAX_STARS
} = constants$3;
const starIconsSources = sourcesStars;
const getStars = getStars_1;
const renderRating = (stars, namespace) => {
  const starsToRender = stars.map((star, index) => {
    const {
      [star]: StarIcon
    } = starIconsSources;
    const isEmpty = star === 'EMPTY';
    const starStyleClasses = `${namespace}__star${isEmpty ? ` ${namespace}__star-empty` : ''}`;
    return StarIcon && /*#__PURE__*/_jsx$y(StarIcon, {
      className: classNames$3(starStyleClasses)
    }, `star-item-${index}`);
  });
  return starsToRender;
};
const Stars$4 = _ref => {
  let {
    className,
    value,
    aria_label
  } = _ref;
  const {
    STARS
  } = getStars(value, MAX_STARS);
  const ratings = renderRating(STARS, className);
  return /*#__PURE__*/_jsx$y("div", {
    className: className
  }, void 0, ratings, /*#__PURE__*/_jsx$y("p", {
    className: "andes-visually-hidden"
  }, void 0, aria_label));
};
Stars$4.defaultProps = _objectSpread$q({}, DF_STARS);
var stars$1 = React$g.memo(Stars$4);
const Stars$3 = stars$1;
var stars = Stars$3;
const {
  bool: bool$9,
  node,
  number: number$a,
  string: string$d
} = require$$2;
const PT_RATING$1 = {
  average: number$a.isRequired,
  children: node,
  mobile: bool$9,
  stars: number$a.isRequired,
  text: string$d
};
const DF_RATING$1 = {
  children: null,
  mobile: true,
  text: null
};
var proptypes$b = {
  PT_RATING: PT_RATING$1,
  DF_RATING: DF_RATING$1
};
var constants$2 = {};
constants$2.STYLE_NAMESPACE = 'ui-review-capability';
constants$2.KIT_DEFAULT_VALUE = 'kit';
var _objectSpread$p = require$$0$2.default;
var _extends$7 = require$$0$3.default;
var _jsx$x = require$$0.default;
var _Info$1, _div;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const React$f = require$$1;
const classnames$j = require$$0$1;
const Stars$2 = stars;
const {
  PT_RATING,
  DF_RATING
} = proptypes$b;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$n
} = constants$2;
const namespace$t = `${STYLE_NAMESPACE$n}__rating`;
const Info$1 = require$$8;
const Tooltip$2 = require$$9;
const {
  Typography
} = require$$2$1;
const Rating$1 = _ref => {
  var _icon$tooltip, _icon$tooltip2, _icon$tooltip3, _icon$tooltip4;
  let {
    average,
    children,
    mobile,
    stars,
    text,
    aria_label,
    isKitLayout,
    icon
  } = _ref;
  return /*#__PURE__*/_jsx$x("div", {
    className: classnames$j({
      [`${namespace$t}-content`]: mobile,
      [`${namespace$t}-content--kit`]: isKitLayout
    }),
    "data-testid": "rating-component"
  }, void 0, /*#__PURE__*/_jsx$x("div", {
    className: classnames$j(namespace$t, {
      [`${namespace$t}--kit`]: isKitLayout
    })
  }, void 0, /*#__PURE__*/React$f.createElement("div", _extends$7({
    "aria-hidden": "true"
  }, isKitLayout && {
    className: classnames$j({
      [`${namespace$t}__average-container`]: isKitLayout
    })
  }), /*#__PURE__*/_jsx$x("p", {
    className: classnames$j(`${namespace$t}__average`, {
      [`${namespace$t}__average--desktop`]: !mobile
    })
  }, void 0, average ? average.toFixed(1) : 0)), /*#__PURE__*/_jsx$x("div", {
    className: `${namespace$t}__start-content`
  }, void 0, /*#__PURE__*/_jsx$x("div", {}, void 0, /*#__PURE__*/_jsx$x(Stars$2, {
    className: `${namespace$t}__rating`,
    value: stars,
    aria_label: aria_label
  })), /*#__PURE__*/_jsx$x("div", {}, void 0, text && /*#__PURE__*/_jsx$x("p", {
    "aria-hidden": "true",
    className: `${namespace$t}__label`
  }, void 0, text), isKitLayout && mobile && /*#__PURE__*/_jsx$x("div", {
    className: `${namespace$t}__tooltip-info`,
    "aria-label": icon === null || icon === void 0 || (_icon$tooltip = icon.tooltip) === null || _icon$tooltip === void 0 || (_icon$tooltip = _icon$tooltip.content) === null || _icon$tooltip === void 0 ? void 0 : _icon$tooltip.text
  }, void 0, /*#__PURE__*/_jsx$x(Tooltip$2, {
    content: icon === null || icon === void 0 || (_icon$tooltip2 = icon.tooltip) === null || _icon$tooltip2 === void 0 || (_icon$tooltip2 = _icon$tooltip2.content) === null || _icon$tooltip2 === void 0 ? void 0 : _icon$tooltip2.text,
    side: icon === null || icon === void 0 || (_icon$tooltip3 = icon.tooltip) === null || _icon$tooltip3 === void 0 || (_icon$tooltip3 = _icon$tooltip3.content) === null || _icon$tooltip3 === void 0 ? void 0 : _icon$tooltip3.position,
    closable: true
  }, void 0, _Info$1 || (_Info$1 = /*#__PURE__*/_jsx$x(Info$1, {}))))))), isKitLayout && !mobile && /*#__PURE__*/_jsx$x("div", {
    className: `${namespace$t}__info-icon`
  }, void 0, _div || (_div = /*#__PURE__*/_jsx$x("div", {}, void 0, /*#__PURE__*/_jsx$x(Info$1, {}))), /*#__PURE__*/_jsx$x("div", {}, void 0, /*#__PURE__*/_jsx$x(Typography, {
    size: "xs",
    color: "secondary",
    type: "body",
    weight: "regular"
  }, void 0, icon === null || icon === void 0 || (_icon$tooltip4 = icon.tooltip) === null || _icon$tooltip4 === void 0 || (_icon$tooltip4 = _icon$tooltip4.content) === null || _icon$tooltip4 === void 0 ? void 0 : _icon$tooltip4.text))), !isKitLayout && /*#__PURE__*/_jsx$x("div", {}, void 0, children));
};
Rating$1.defaultProps = _objectSpread$p({}, DF_RATING);
var rating = React$f.memo(Rating$1);
const {
  arrayOf: arrayOf$9,
  number: number$9,
  shape: shape$b,
  string: string$c
} = require$$2;
const PT_PROGRESS_BAR$1 = {
  className: string$c.isRequired,
  percentage: number$9
};
const DF_PROGRESS_BAR$1 = {
  percentage: 0
};
const PT_RATING_LEVELS$1 = {
  levels: arrayOf$9(shape$b({
    label: string$c,
    percentage: number$9.isRequired,
    value: number$9.isRequired
  })).isRequired
};
var proptypes$a = {
  PT_PROGRESS_BAR: PT_PROGRESS_BAR$1,
  DF_PROGRESS_BAR: DF_PROGRESS_BAR$1,
  PT_RATING_LEVELS: PT_RATING_LEVELS$1
};
var _objectSpread$o = require$$0$2.default;
var _jsx$w = require$$0.default;
const React$e = require$$1;
const {
  PT_PROGRESS_BAR,
  DF_PROGRESS_BAR
} = proptypes$a;
const ProgressBar$3 = _ref => {
  let {
    className,
    percentage
  } = _ref;
  return /*#__PURE__*/_jsx$w("div", {
    className: className,
    "data-testid": "progress-bar"
  }, void 0, /*#__PURE__*/_jsx$w("span", {
    className: `${className}__background`
  }), /*#__PURE__*/_jsx$w("span", {
    className: `${className}__fill-background`,
    style: {
      width: `${percentage}%`
    }
  }));
};
ProgressBar$3.defaultProps = _objectSpread$o({}, DF_PROGRESS_BAR);
var progressBar$1 = React$e.memo(ProgressBar$3);
const ProgressBar$2 = progressBar$1;
var progressBar = ProgressBar$2;
var _objectSpread$n = require$$0$2.default;
var _jsx$v = require$$0.default;
const React$d = require$$1;
const ProgressBar$1 = progressBar;
const StarEmptyIcon$1 = starEmpty;
const {
  PT_RATING_LEVELS
} = proptypes$a;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$m
} = constants$2;
const namespace$s = `${STYLE_NAMESPACE$m}-rating`;
const RatingLevels$1 = React$d.forwardRef((_ref, ref) => {
  let {
    levels
  } = _ref;
  return /*#__PURE__*/React$d.createElement("ul", {
    className: namespace$s,
    ref: ref,
    "aria-hidden": "true"
  }, levels.map(_ref2 => {
    let {
      index,
      percentage
    } = _ref2;
    return /*#__PURE__*/_jsx$v("li", {
      className: `${namespace$s}__level`
    }, `${namespace$s}__level-${index}`, /*#__PURE__*/_jsx$v("div", {
      "aria-hidden": "true",
      className: `${namespace$s}__level__column ${namespace$s}__level__progress-bar-container`
    }, void 0, /*#__PURE__*/_jsx$v(ProgressBar$1, {
      className: `${namespace$s}__level__progress-bar`,
      percentage: percentage
    })), /*#__PURE__*/_jsx$v("div", {
      className: `${namespace$s}__level__value-container`
    }, void 0, /*#__PURE__*/_jsx$v("span", {}, void 0, 5 - index), /*#__PURE__*/_jsx$v("div", {
      className: `${namespace$s}__start-container`
    }, void 0, /*#__PURE__*/_jsx$v(StarEmptyIcon$1, {
      className: `${namespace$s}__start`
    }))));
  }));
});
RatingLevels$1.propTypes = _objectSpread$n({}, PT_RATING_LEVELS);
var ratingLevels = React$d.memo(RatingLevels$1);
var track = {};
const {
  shape: shape$a,
  string: string$b
} = require$$2;
track.PT_TRACK = {
  event_data: shape$a({
    catalog_product_id: string$b,
    type: string$b
  }),
  path: string$b
};
const {
  func: func$9,
  shape: shape$9,
  string: string$a
} = require$$2;
const {
  PT_TRACK: PT_TRACK$4
} = track;
const PT_BUY_BUTTON$1 = {
  buy_button: shape$9({
    text: string$a,
    track: PT_TRACK$4,
    url: string$a
  }),
  onBuyClick: func$9
};
const DF_BUY_BUTTON$1 = {
  buy_button: null,
  onBuyClick: null
};
var proptypes$9 = {
  PT_BUY_BUTTON: PT_BUY_BUTTON$1,
  DF_BUY_BUTTON: DF_BUY_BUTTON$1
};
var _objectSpread$m = require$$0$2.default;
var _jsx$u = require$$0.default;
const Button$6 = require$$3;
const {
  PT_BUY_BUTTON,
  DF_BUY_BUTTON
} = proptypes$9;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$l
} = constants$2;
const namespace$r = `${STYLE_NAMESPACE$l}-buy-button`;
const BuyButton$1 = _ref => {
  let {
    buy_button,
    onBuyClick
  } = _ref;
  const handleBuy = e => {
    if (onBuyClick) {
      e.preventDefault();
      onBuyClick(buy_button.url, buy_button.track);
    }
  };
  return /*#__PURE__*/_jsx$u("div", {
    className: namespace$r,
    "data-testid": "buy-button"
  }, void 0, /*#__PURE__*/_jsx$u(Button$6, {
    className: `${namespace$r}__button-action`,
    hierarchy: "transparent",
    size: "small",
    "data-testid": "buy-item",
    href: buy_button.url,
    onClick: handleBuy,
    "aria-hidden": true
  }, void 0, buy_button.text));
};
BuyButton$1.defaultProps = _objectSpread$m({}, DF_BUY_BUTTON);
var buyButton = BuyButton$1;
const {
  arrayOf: arrayOf$8,
  bool: bool$8,
  func: func$8,
  number: number$8,
  shape: shape$8,
  string: string$9
} = require$$2;
const PT_CATEGORIES$1 = {
  items: arrayOf$8(shape$8({
    display_text: string$9,
    name: string$9,
    value: number$8
  })),
  mobile: bool$8,
  onSeeMoreClick: func$8,
  show_see_more: string$9,
  title: string$9,
  vpp: bool$8
};
const DF_CATEGORIES$1 = {
  items: null,
  mobile: true,
  onSeeMoreClick: () => {},
  show_see_more: null,
  title: '',
  vpp: false
};
const PT_CATEGORY$1 = {
  attr: shape$8({}),
  mobile: bool$8
};
const DF_CATEGORY$1 = {};
var proptypes$8 = {
  PT_CATEGORIES: PT_CATEGORIES$1,
  DF_CATEGORIES: DF_CATEGORIES$1,
  PT_CATEGORY: PT_CATEGORY$1,
  DF_CATEGORY: DF_CATEGORY$1
};
var constants$1 = {};
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$k
} = constants$2;
constants$1.NAMESPACE = `${STYLE_NAMESPACE$k}-categories`;
var _objectSpread$l = require$$0$2.default;
var _jsx$t = require$$0.default;
const React$c = require$$1;
const classnames$i = require$$0$1;
const {
  PT_CATEGORY,
  DF_CATEGORY
} = proptypes$8;
const {
  NAMESPACE: NAMESPACE$6
} = constants$1;
const Stars$1 = stars;
const Category$1 = _ref => {
  let {
    attr,
    mobile
  } = _ref;
  return /*#__PURE__*/_jsx$t("tr", {
    className: classnames$i({
      [`${NAMESPACE$6}__desktop--row`]: !mobile,
      [`${NAMESPACE$6}__mobile--row`]: mobile
    })
  }, void 0, /*#__PURE__*/_jsx$t("td", {
    className: classnames$i({
      [`${NAMESPACE$6}__max-row-w`]: attr.display_text.length > 24 && mobile
    })
  }, void 0, attr.display_text), /*#__PURE__*/_jsx$t("td", {}, void 0, /*#__PURE__*/_jsx$t(Stars$1, {
    "aria-hidden": "true",
    className: `${NAMESPACE$6}__rating`,
    value: attr.value,
    aria_label: attr.aria_label
  })));
};
Category$1.defaultProps = _objectSpread$l({}, DF_CATEGORY);
var category = React$c.memo(Category$1);
var _objectSpread$k = require$$0$2.default;
var _jsx$s = require$$0.default;
const {
  PT_CATEGORIES,
  DF_CATEGORIES
} = proptypes$8;
const {
  NAMESPACE: NAMESPACE$5
} = constants$1;
const Category = category;
const Categories$1 = _ref => {
  let {
    items,
    mobile,
    title,
    vpp
  } = _ref;
  const VPP_MOBILE = vpp && mobile;
  const ATTRIBUTES = items;
  return /*#__PURE__*/_jsx$s("div", {
    className: NAMESPACE$5,
    "data-testid": "categories-component"
  }, void 0, !VPP_MOBILE && /*#__PURE__*/_jsx$s("p", {
    className: `${NAMESPACE$5}__title`
  }, void 0, title), /*#__PURE__*/_jsx$s("table", {
    className: `${NAMESPACE$5}__attributes`
  }, void 0, /*#__PURE__*/_jsx$s("tbody", {}, void 0, ATTRIBUTES === null || ATTRIBUTES === void 0 ? void 0 : ATTRIBUTES.map((attr, index) => /*#__PURE__*/_jsx$s(Category, {
    attr: attr,
    mobile: mobile
  }, `${NAMESPACE$5}--row-${index}`)))));
};
Categories$1.defaultProps = _objectSpread$k({}, DF_CATEGORIES);
var categories = Categories$1;
const {
  arrayOf: arrayOf$7,
  bool: bool$7,
  func: func$7,
  shape: shape$7,
  string: string$8,
  number: number$7
} = require$$2;
const PT_TRACK$3 = track;
const PT_DROPDOWN$1 = {
  items: arrayOf$7(shape$7({
    text: string$8,
    value: string$8
  })),
  itemValueVpp: shape$7({
    orderCriteria: string$8,
    rating: string$8
  }),
  keyObject: string$8,
  label: string$8,
  onFilter: func$7,
  starts: bool$7,
  vpp: bool$7
};
const DF_DROPDOWN$1 = {
  items: [],
  keyObject: null,
  label: null,
  onFilter: () => {},
  starts: false
};
const PT_FILTER_BOTTOM_SHEET$1 = {
  button_text: string$8,
  clean_filters: string$8,
  inline_official_store_filter: shape$7({
    title: shape$7({
      text: string$8
    }),
    track: PT_TRACK$3,
    value: bool$7
  }),
  internal_title: string$8,
  itemValueVpp: shape$7({
    orderCriteria: string$8,
    rating: string$8
  }),
  official_store_filter: shape$7({
    title: shape$7({
      text: string$8,
      icon: shape$7({
        url: string$8
      })
    }),
    track: PT_TRACK$3,
    value: bool$7
  }),
  onCleanFilters: func$7,
  onFilter: func$7,
  order_by: shape$7({
    items: arrayOf$7(shape$7({
      text: string$8,
      track: PT_TRACK$3,
      value: string$8
    })),
    title: string$8,
    value: string$8
  }),
  qualification: shape$7({
    items: arrayOf$7(shape$7({
      text: string$8,
      track: PT_TRACK$3,
      value: string$8
    })),
    title: string$8,
    value: string$8
  }),
  title: string$8,
  total_opinions: string$8,
  vpp: bool$7
};
const DF_FILTER_BOTTOM_SHEET$1 = {
  button_text: null,
  clean_filters: null,
  inline_official_store_filter: null,
  internal_title: null,
  itemValueVpp: {},
  official_store_filter: null,
  order_by: {},
  qualification: {},
  title: null,
  total_opinions: null,
  vpp: false
};
const PT_FILTER$1 = {
  button_sheet_title: string$8,
  button_text: string$8,
  clean_filters: string$8,
  filterOptionsVpp: shape$7({
    orderCriteria: string$8,
    rating: string$8
  }),
  inline_official_store_filter: shape$7({
    title: shape$7({
      text: string$8
    }),
    track: PT_TRACK$3,
    value: bool$7
  }),
  internal_title: string$8,
  islogged: bool$7,
  levels: arrayOf$7(shape$7({
    label: string$8,
    percentage: number$7,
    value: number$7
  })),
  message: shape$7({
    subtitle: string$8,
    title: string$8,
    type: string$8
  }),
  mobile: bool$7,
  official_store_filter: shape$7({
    title: shape$7({
      text: string$8
    }),
    track: PT_TRACK$3,
    value: bool$7
  }),
  onCleanFilters: func$7,
  onClickCarouselImage: func$7,
  onDenounceClick: func$7,
  onDislikeComment: func$7,
  onFilterClick: func$7,
  onLikeComment: func$7,
  onShowAll: func$7,
  order_by: shape$7({
    items: arrayOf$7(shape$7({
      text: string$8,
      track: PT_TRACK$3,
      value: string$8
    })),
    title: string$8,
    value: string$8
  }),
  qualification: shape$7({
    items: arrayOf$7(shape$7({
      text: string$8,
      track: PT_TRACK$3,
      value: string$8
    })),
    title: string$8,
    value: string$8
  }),
  reviews: arrayOf$7(shape$7({
    content: string$8,
    dislikes: number$7,
    id: number$7.isRequired,
    likes: number$7,
    rate: number$7,
    title: shape$7({
      text: string$8
    }),
    version: shape$7({
      text: string$8
    })
  })),
  showAllButton: shape$7({
    text: string$8,
    track: PT_TRACK$3,
    url: string$8
  }),
  title: string$8,
  total_opinions: string$8,
  vpp: bool$7
};
const DF_FILTER$1 = {
  button_text: null,
  clean_filters: null,
  filterOptionsVpp: {},
  inline_official_store_filter: null,
  internal_title: null,
  islogged: false,
  levels: [],
  message: null,
  mobile: false,
  official_store_filter: null,
  order_by: {},
  qualification: {},
  reviews: [],
  showAllButton: {},
  title: null,
  total_opinions: null,
  vpp: false
};
const PT_SWITCH_FILTER$1 = {
  onFilter: func$7,
  title: shape$7({
    text: string$8.isRequired
  }).isRequired,
  track: PT_TRACK$3,
  value: bool$7
};
const DP_SWITCH_FILTER$1 = {
  onFilter: () => {},
  value: false
};
const PT_FILTER_LABEL$1 = {
  title: string$8,
  track: PT_TRACK$3,
  itemValueVpp: bool$7,
  keyObject: string$8,
  onFilter: func$7,
  vpp: bool$7
};
const DF_FILTER_LABEL$1 = {
  title: null,
  track: null,
  keyObject: null,
  onFilter: () => {}
};
var proptypes$7 = {
  PT_DROPDOWN: PT_DROPDOWN$1,
  DF_DROPDOWN: DF_DROPDOWN$1,
  PT_FILTER_BOTTOM_SHEET: PT_FILTER_BOTTOM_SHEET$1,
  DF_FILTER_BOTTOM_SHEET: DF_FILTER_BOTTOM_SHEET$1,
  PT_FILTER: PT_FILTER$1,
  DF_FILTER: DF_FILTER$1,
  PT_SWITCH_FILTER: PT_SWITCH_FILTER$1,
  DP_SWITCH_FILTER: DP_SWITCH_FILTER$1,
  PT_FILTER_LABEL: PT_FILTER_LABEL$1,
  DF_FILTER_LABEL: DF_FILTER_LABEL$1
};
var _objectSpread$j = require$$0$2.default;
var _jsx$r = require$$0.default;
const {
  useState: useState$9,
  useEffect: useEffect$7
} = require$$1;
const classnames$h = require$$0$1;
const Button$5 = require$$3;
const Chevron$1 = chevron;
const StarEmptyIcon = starEmpty;
const {
  PT_DROPDOWN,
  DF_DROPDOWN
} = proptypes$7;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$j
} = constants$2;
const namespace$q = `${STYLE_NAMESPACE$j}-dropdown`;
const FilterDropdown$1 = _ref => {
  let {
    items,
    itemValueVpp,
    keyObject,
    label,
    onFilter,
    starts,
    vpp
  } = _ref;
  const [open, setOpen] = useState$9(false);
  const [itemValue, setItemValue] = useState$9(itemValueVpp || null);
  useEffect$7(() => {
    const closeDropdown = e => {
      var _e$path;
      const dropdownElement = e === null || e === void 0 || (_e$path = e.path) === null || _e$path === void 0 ? void 0 : _e$path.filter(_ref2 => {
        let {
          localName
        } = _ref2;
        return localName === 'button' || localName === 'li';
      });
      if ((dropdownElement === null || dropdownElement === void 0 ? void 0 : dropdownElement.length) === 0) {
        setOpen(false);
      }
    };
    document.body.addEventListener('click', closeDropdown);
    return () => document.body.removeEventListener('click', closeDropdown);
  }, []);
  const handleFilter = (value, track) => {
    setItemValue(value);
    onFilter(value, keyObject, track);
    setOpen(!open);
  };
  const FILTER_APPLICATED = 1;
  const ALL = 'all';
  return /*#__PURE__*/_jsx$r("div", {
    className: namespace$q,
    "data-testid": `dropdown-${keyObject}`
  }, void 0, /*#__PURE__*/_jsx$r("div", {
    className: `${namespace$q}__action`
  }, void 0, /*#__PURE__*/_jsx$r(Button$5, {
    className: `${itemValue && itemValue !== ALL && !vpp ? 'active' : ''}`,
    "aria-haspopup": "menu",
    onClick: () => {
      setOpen(!open);
    }
  }, void 0, label, itemValue && itemValue !== ALL && !vpp && /*#__PURE__*/_jsx$r("span", {
    className: `${namespace$q}__options-num`
  }, void 0, "(", FILTER_APPLICATED, ")"), /*#__PURE__*/_jsx$r(Chevron$1, {
    className: `${namespace$q}__chevron`
  }))), open && /*#__PURE__*/_jsx$r("div", {
    className: `${namespace$q}__content`
  }, void 0, /*#__PURE__*/_jsx$r("ul", {}, void 0, items.map((_ref3, index) => {
    let {
      text,
      value,
      track
    } = _ref3;
    return /*#__PURE__*/_jsx$r("li", {
      className: classnames$h(`${namespace$q}__options`, {
        selected: itemValue === value && !vpp
      }),
      "data-testid": `filterItem-${keyObject}-${index}`,
      onClick: handleFilter.bind(undefined, value, track)
    }, `${namespace$q}__options-${index}`, text, starts && value !== 'all' && /*#__PURE__*/_jsx$r(StarEmptyIcon, {
      className: `${namespace$q}__start`
    }));
  }))));
};
FilterDropdown$1.defaultProps = _objectSpread$j({}, DF_DROPDOWN);
var dropdown = FilterDropdown$1;
const DEFAULT_SIZE$2 = false;
const classnames$g = require$$0$1;
const namespace$p = 'ui-reviews-font-size';
const fontSize$1 = font => {
  const sizeName = typeof font === 'string' ? font : DEFAULT_SIZE$2;
  return classnames$g({
    [`${namespace$p}--${sizeName}`]: sizeName
  });
};
var fontSize_1 = fontSize$1;
const classnames$f = require$$0$1;
const DEFAULT_COLOR = false;
const namespace$o = 'ui-reviews-color';
const colornames$1 = color => {
  const colorName = typeof color === 'string' ? color : DEFAULT_COLOR;
  return classnames$f({
    [`${namespace$o}--${colorName}`]: colorName
  });
};
var colornames_1 = colornames$1;
const classnames$e = require$$0$1;
const DEFAULT_FAMILY = false;
const namespace$n = 'ui-reviews-weight';
const fontWeight$1 = weight => {
  const weightName = typeof weight === 'string' ? weight : DEFAULT_FAMILY;
  return classnames$e({
    [`${namespace$n}--${weightName}`]: weightName
  });
};
var fontWeight_1 = fontWeight$1;
const classnames$d = require$$0$1;
const DEFAULT_BG_COLOR = false;
const namespace$m = 'ui-reviews-background-color';
const backgroundColor$1 = background => {
  const colorName = typeof background === 'string' ? background : background && DEFAULT_BG_COLOR;
  return classnames$d({
    [`${namespace$m}--${colorName}`]: colorName
  });
};
var backgroundColor_1 = backgroundColor$1;
const DEFAULT_SIZE$1 = false;
const classnames$c = require$$0$1;
const namespace$l = 'ui-reviews-margin-bottom';
const marginBottom$2 = margin => {
  const sizeName = typeof margin === 'string' ? margin : DEFAULT_SIZE$1;
  return classnames$c({
    [`${namespace$l}--${sizeName}`]: sizeName
  });
};
var marginBottom_1 = marginBottom$2;
const DEFAULT_SIZE = false;
const classnames$b = require$$0$1;
const namespace$k = 'ui-reviews-margin-top';
const marginBottom$1 = margin => {
  const sizeName = typeof margin === 'string' ? margin : DEFAULT_SIZE;
  return classnames$b({
    [`${namespace$k}--${sizeName}`]: sizeName
  });
};
var marginTop$1 = marginBottom$1;
const classnames$a = require$$0$1;
const namespace$j = 'ui-reviews-component-hover';
const componentHover$1 = hover => {
  const response = classnames$a({
    [`${namespace$j}`]: hover
  });
  return response;
};
var componentHover_1 = componentHover$1;
const classnames$9 = require$$0$1;
const fontSize = fontSize_1;
const colornames = colornames_1;
const fontWeight = fontWeight_1;
const backgroundColor = backgroundColor_1;
const marginBottom = marginBottom_1;
const marginTop = marginTop$1;
const componentHover = componentHover_1;
const applyClasses = _ref => {
  let {
    font_size: font,
    font_weight: weight,
    background_color: background,
    className,
    color,
    margin_bottom,
    margin_top,
    hover
  } = _ref;
  return classnames$9(backgroundColor(background), colornames(color), fontSize(font), fontWeight(weight), marginBottom(margin_bottom), marginTop(margin_top), componentHover(hover), className);
};
var applyClasses_1 = applyClasses;
var _jsx$q = require$$0.default;
var _path$1;
const classnames$8 = require$$0$1;
const namespace$i = 'ui-reviews-icon ui-reviews-icon--cockade';

/* eslint-disable max-len */
const IconCockade$1 = _ref => {
  let {
    className,
    text
  } = _ref;
  return /*#__PURE__*/_jsx$q("svg", {
    className: classnames$8(namespace$i, className),
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": text
  }, void 0, _path$1 || (_path$1 = /*#__PURE__*/_jsx$q("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.31573 1.10365L9.66122 2.33868L10.8962 2.68504C11.3429 2.81043 11.7072 3.13382 11.8848 3.56238C12.0624 3.99094 12.0335 4.47728 11.8064 4.88179L11.1781 5.99994L11.8055 7.11722C12.033 7.52169 12.0622 8.00816 11.8848 8.43693C11.7073 8.8657 11.343 9.18932 10.8962 9.31484L9.66122 9.6612L9.31487 10.8962C9.18948 11.3429 8.86609 11.7072 8.43754 11.8848C8.00898 12.0624 7.52264 12.0335 7.11813 11.8064L6 11.1781L4.88273 11.8055C4.47826 12.033 3.9918 12.0622 3.56303 11.8848C3.13427 11.7073 2.81066 11.343 2.68513 10.8962L2.33878 9.6612L1.10376 9.31484C0.657141 9.18945 0.292755 8.86606 0.115195 8.4375C-0.0623645 8.00894 -0.0334609 7.5226 0.193609 7.11808L0.821861 5.99994L0.194469 4.88265C-0.0329578 4.47819 -0.0621606 3.99171 0.115247 3.56295C0.292655 3.13418 0.657042 2.81056 1.10376 2.68504L2.33878 2.33868L2.68513 1.10365C2.81059 0.657278 3.13383 0.293104 3.56215 0.11557C3.99048 -0.0619647 4.47657 -0.0332466 4.88101 0.193488L5.99914 0.821747L7.11642 0.194347C7.46607 -0.00238688 7.87955 -0.0521524 8.2659 0.056C8.65225 0.164152 8.9798 0.421362 9.1765 0.771039C9.23666 0.875892 9.28307 0.987621 9.31573 1.10365ZM7.84246 3.95962L5.29765 6.50617L4.15631 5.36224C4.08722 5.29097 3.99172 5.25146 3.89246 5.25309C3.79321 5.25146 3.69771 5.29097 3.62862 5.36224L3.10006 5.88908C3.02901 5.95826 2.98981 6.05379 2.99177 6.15294C2.99177 6.25607 3.02787 6.34373 3.10006 6.41593L5.0338 8.34625C5.10304 8.41721 5.19853 8.4564 5.29765 8.45454C5.39674 8.4562 5.49215 8.41704 5.5615 8.34625L8.89957 5.0133C8.97062 4.94412 9.00982 4.8486 9.00786 4.74945C9.00959 4.6506 8.9704 4.55544 8.89957 4.48646L8.37102 3.95876C8.30178 3.8878 8.20629 3.84861 8.10717 3.85047C8.00718 3.84947 7.9117 3.88866 7.84246 3.95962Z",
    fill: "#3483FA"
  })));
};
IconCockade$1.defaultProps = {
  className: null
};
var cockade = IconCockade$1;
var _jsx$p = require$$0.default;
const PropTypes = require$$2;
const IconCockade = cockade;
const icons = {
  cockade: _ref => {
    let {
      text
    } = _ref;
    return /*#__PURE__*/_jsx$p(IconCockade, {
      text: text
    });
  }
};
const getIcon$1 = (icon, text, color) => icons[icon] ? icons[icon]({
  text,
  color
}) : null;
getIcon$1.defaultProps = {
  icon: null,
  text: null,
  color: null
};
getIcon$1.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string,
  color: PropTypes.string
};
var getIcon_1 = getIcon$1;
var _jsx$o = require$$0.default;
const {
  useState: useState$8,
  useEffect: useEffect$6
} = require$$1;
const classnames$7 = require$$0$1;
const classname$1 = require$$0$1;
const ApplyStylesClasses = applyClasses_1;
const getIcon = getIcon_1;
const TRANSLATION_TYPE_ICON = 'ICON';
const INTERPOLATION_REGEXP = /{([\s\S]+?)}/g;

/**
 * @param {string} text
 * @param {array} values
 * @param {object} styles
 * @param {string} class_name
 */
const StyleLabel$3 = _ref => {
  var _text$match;
  let {
    text,
    values = null,
    styles = null,
    class_name = null
  } = _ref;
  const [content, setContent] = useState$8(values);
  useEffect$6(() => {
    setContent(values);
  }, [values]);
  const namespace = class_name ? `ui-reviews-label-icon ${class_name}` : 'ui-reviews-label-icon';
  const hasOwnProperty = (object, key) => `{${object.tag}}` === key;
  const result = text.split(INTERPOLATION_REGEXP).filter(res => !!res.trim());
  const vars = text === null || text === void 0 || (_text$match = text.match(/\{([^{}]*)\}/g)) === null || _text$match === void 0 ? void 0 : _text$match.map(str => str.trim());
  const replacements = vars === null || vars === void 0 ? void 0 : vars.map(variable => content.find(value => hasOwnProperty(value, variable)) || variable);
  for (let index = 0; index < result.length; index += 1) {
    const key = result[index];
    if (key) {
      const replacement = replacements && replacements.find(replace => hasOwnProperty(replace, `{${key}}`));
      if (replacement) {
        switch (replacement.type) {
          case TRANSLATION_TYPE_ICON:
            result[index] = getIcon(replacement.icon_id, replacement.text, replacement.color);
            break;
          default:
            result[index] = /*#__PURE__*/_jsx$o("span", {
              className: classname$1(namespace, {
                [`${styles ? ApplyStylesClasses(styles) : ''}`]: styles
              })
            }, void 0, key && key.trim());
        }
      } else if (key !== '') {
        result[index] = /*#__PURE__*/_jsx$o("span", {
          className: classname$1(namespace, {
            [`${styles ? ApplyStylesClasses(styles) : ''}`]: styles
          })
        }, void 0, key && key.trim());
      }
    }
  }
  return /*#__PURE__*/_jsx$o("p", {
    className: classnames$7(class_name, namespace, {
      [`${styles ? ApplyStylesClasses(styles) : ''}`]: styles
    })
  }, void 0, result);
};
var styleLabel = StyleLabel$3;
var _objectSpread$i = require$$0$2.default;
var _jsx$n = require$$0.default;
const React$b = require$$1;
const {
  useState: useState$7,
  useEffect: useEffect$5
} = React$b;
const classnames$6 = require$$0$1;
const FeedbackPositive18 = require$$4;
const StyleLabel$2 = styleLabel;
const {
  PT_FILTER_LABEL,
  DF_FILTER_LABEL
} = proptypes$7;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$i
} = constants$2;
const namespace$h = `${STYLE_NAMESPACE$i}-filterLabel`;
const FilterLabel$1 = _ref => {
  let {
    title,
    track,
    itemValueVpp,
    keyObject,
    onFilter,
    vpp,
    official_store_id
  } = _ref;
  const [filteredTO, setFilteredTO] = useState$7();
  useEffect$5(() => {
    if ((filteredTO === false || filteredTO === null) && itemValueVpp !== null) {
      setFilteredTO(false);
    } else {
      setFilteredTO(itemValueVpp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemValueVpp]);
  return /*#__PURE__*/_jsx$n("div", {
    className: namespace$h,
    "data-testid": `filterLabel-${keyObject}`
  }, void 0, /*#__PURE__*/_jsx$n("div", {
    className: `${namespace$h}__action`
  }, void 0, /*#__PURE__*/_jsx$n("button", {
    className: classnames$6(`${namespace$h}__action__filterlabel`, {
      active: filteredTO && !vpp
    }),
    "aria-haspopup": "menu",
    onClick: () => {
      if (!vpp) setFilteredTO(!filteredTO);
      onFilter(filteredTO ? 'all' : official_store_id, keyObject, filteredTO ? null : track);
    }
  }, void 0, /*#__PURE__*/React$b.createElement(StyleLabel$2, title), filteredTO && !vpp && /*#__PURE__*/_jsx$n("span", {
    className: "icon-feedbackPositive"
  }, void 0, /*#__PURE__*/_jsx$n(FeedbackPositive18, {
    className: `${namespace$h}__feedbackPositive`,
    color: "#3483FA"
  })))));
};
FilterLabel$1.defaultProps = _objectSpread$i({}, DF_FILTER_LABEL);
var filterLabel = FilterLabel$1;
var _objectSpread$h = require$$0$2.default;
const {
  arrayOf: arrayOf$6,
  bool: bool$6,
  func: func$6,
  number: number$6,
  shape: shape$6,
  string: string$7
} = require$$2;
const {
  PT_TRACK: PT_TRACK$2
} = track;
const PT_COMMENT_CONTENT$1 = {
  content: shape$6({
    max_characters: number$6,
    see_more: string$7,
    text: string$7.isRequired
  }),
  date: string$7,
  gallery: bool$6,
  mobile: bool$6
};
const DF_COMMENT_CONTENT$1 = {
  content: null,
  gallery: false,
  mobile: true
};
const PT_COMMENT$1 = {
  actions: arrayOf$6(shape$6({
    id: string$7,
    text: string$7,
    value: number$6
  }), shape$6({
    id: string$7,
    value: number$6
  })),
  carousel: shape$6({}),
  className: string$7,
  comment: shape$6(_objectSpread$h(_objectSpread$h({}, PT_COMMENT_CONTENT$1), {}, {
    country: string$7,
    date: string$7,
    denounce: {
      onDenounceClick: func$6,
      text: string$7,
      track: PT_TRACK$2,
      url: string$7
    }
  })),
  denounce: shape$6({}),
  dislikeHref: string$7,
  gallery: bool$6,
  id: string$7.isRequired,
  isCarouselComment: bool$6,
  islogged: bool$6,
  likeHref: string$7,
  mobile: bool$6,
  onClickCarouselImage: func$6,
  onDenounceClick: func$6.isRequired,
  onDislikeComment: func$6,
  onLikeComment: func$6,
  rating: number$6 || string$7,
  updateActions: func$6,
  variant: string$7,
  vpp: bool$6
};
const DF_COMMENT$1 = {
  actions: null,
  comment: {},
  denounce: null,
  dislikeHref: '',
  id: '',
  isCarouselComment: false,
  islogged: false,
  likeHref: '',
  mobile: true,
  onDenounceClick: () => {},
  onDislikeComment: () => {},
  onLikeComment: () => {},
  rating: null,
  variant: null,
  vpp: false
};
var proptypes$6 = {
  PT_COMMENT: PT_COMMENT$1,
  DF_COMMENT: DF_COMMENT$1,
  PT_COMMENT_CONTENT: PT_COMMENT_CONTENT$1,
  DF_COMMENT_CONTENT: DF_COMMENT_CONTENT$1
};
var _objectSpread$g = require$$0$2.default;
var _jsx$m = require$$0.default;
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const React$a = require$$1;
const classnames$5 = require$$0$1;
const {
  useState: useState$6,
  useEffect: useEffect$4,
  useRef: useRef$1
} = require$$1;
const {
  PT_COMMENT_CONTENT,
  DF_COMMENT_CONTENT
} = proptypes$6;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$h
} = constants$2;
const namespace$g = `${STYLE_NAMESPACE$h}-comments__comment__content`;
const CommentContent$1 = _ref => {
  let {
    content,
    date,
    gallery,
    mobile,
    vpp
  } = _ref;
  const [readMore, setReadMore] = useState$6(true);
  const [showButton, setShowButton] = useState$6(false);
  const contentRef = useRef$1(null);
  const {
    max_characters: maxCharacters,
    see_less: seeLess,
    see_more: seeMore,
    text
  } = content;
  const noTextCommentGallery = gallery && !text;
  const maxCharacterValidation = maxCharacters && text.length > maxCharacters;
  const isMobileOrVpp = gallery && mobile || mobile && vpp || vpp;
  useEffect$4(() => {
    if (contentRef.current) {
      const {
        scrollHeight
      } = contentRef.current;
      const lineHeight = parseFloat(getComputedStyle(contentRef.current).lineHeight);
      const numberOfLines = Math.ceil(scrollHeight / lineHeight) - 1;
      setShowButton(numberOfLines > 3);
    }
  }, [text, readMore]);
  const showReadMore = () => noTextCommentGallery && readMore || maxCharacterValidation && readMore;
  const onReadMoreClick = () => {
    setReadMore(!readMore);
  };
  const expandedReviewClassName = classnames$5(namespace$g, {
    [`${namespace$g}--closed`]: showReadMore() && isMobileOrVpp,
    [namespace$g]: !showReadMore()
  });
  return /*#__PURE__*/React$a.createElement(React$a.Fragment, null, /*#__PURE__*/React$a.createElement("p", {
    ref: contentRef,
    role: "presentation",
    className: classnames$5(expandedReviewClassName),
    "data-testid": "comment-content-component"
  }, text, gallery && /*#__PURE__*/_jsx$m("span", {
    className: "date-comment-gallery"
  }, void 0, date)), showButton && isMobileOrVpp && /*#__PURE__*/_jsx$m("span", {
    className: `${namespace$g}__read-more`,
    "data-testid": "comment-read-more",
    onClick: onReadMoreClick
  }, void 0, showReadMore() ? seeMore : maxCharacterValidation && seeLess));
};
CommentContent$1.defaultProps = _objectSpread$g({}, DF_COMMENT_CONTENT);
var commentContent = CommentContent$1;
var constants = {};
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$g
} = constants$2;
constants.NAMESPACE = `${STYLE_NAMESPACE$g}-comments__review-comment__denounce`;
constants.QUANTITY_DOTS = 3;
const {
  func: func$5,
  string: string$6
} = require$$2;
const {
  PT_TRACK: PT_TRACK$1
} = track;
const PT_THREEDOTS_MENU_BUTTON$1 = {
  device: string$6.isRequired,
  handleMenu: func$5.isRequired,
  text: string$6
};
const DF_THREEDOTS_MENU_BUTTON$1 = {
  device: 'desktop',
  handleMenu: () => {}
};
const PT_THREEDOTS_MENU_CONTENT$1 = {
  handleOnDenounce: func$5,
  text: string$6,
  url: string$6
};
const DF_THREEDOTS_MENU_CONTENT$1 = {
  isDesktop: false,
  handleOnDenounce: () => {}
};
const PT_THREEDOTS_MENU$2 = {
  onDenounceClick: func$5,
  text: string$6,
  track: PT_TRACK$1,
  url: string$6
};
const DF_THREEDOTS_MENU$2 = {
  text: null,
  track: {},
  url: null
};
var proptypes$5 = {
  PT_THREEDOTS_MENU: PT_THREEDOTS_MENU$2,
  DF_THREEDOTS_MENU: DF_THREEDOTS_MENU$2,
  PT_THREEDOTS_MENU_BUTTON: PT_THREEDOTS_MENU_BUTTON$1,
  DF_THREEDOTS_MENU_BUTTON: DF_THREEDOTS_MENU_BUTTON$1,
  PT_THREEDOTS_MENU_CONTENT: PT_THREEDOTS_MENU_CONTENT$1,
  DF_THREEDOTS_MENU_CONTENT: DF_THREEDOTS_MENU_CONTENT$1
};
var _objectSpread$f = require$$0$2.default;
var _jsx$l = require$$0.default;
var _span;
const Button$4 = require$$3;
const {
  NAMESPACE: NAMESPACE$4,
  QUANTITY_DOTS
} = constants;
const {
  DF_THREEDOTS_MENU_BUTTON,
  PT_THREEDOTS_MENU_BUTTON
} = proptypes$5;
const ThreedotsMenuButton$3 = _ref => {
  let {
    handleMenu,
    device,
    text
  } = _ref;
  return /*#__PURE__*/_jsx$l(Button$4, {
    srLabel: text,
    className: `${NAMESPACE$4}-button`,
    "data-testid": "denounce-button",
    onClick: handleMenu,
    hierarchy: "transparent"
  }, void 0, device === 'desktop' && /*#__PURE__*/_jsx$l("span", {
    className: "andes-visually-hidden",
    role: "button"
  }, void 0, " ", text, " "), QUANTITY_DOTS && Array.from({
    length: QUANTITY_DOTS
  }, () => _span || (_span = /*#__PURE__*/_jsx$l("span", {
    className: "denounce-dropdown__circle"
  }))));
};
ThreedotsMenuButton$3.defaultProps = _objectSpread$f({}, DF_THREEDOTS_MENU_BUTTON);
var threedotsMenuButton = ThreedotsMenuButton$3;
var _objectSpread$e = require$$0$2.default;
var _jsx$k = require$$0.default;
var _FlagIcon;
const {
  NAMESPACE: NAMESPACE$3
} = constants;
const {
  DF_THREEDOTS_MENU_CONTENT,
  PT_THREEDOTS_MENU_CONTENT
} = proptypes$5;
const {
  FlagIcon
} = icons$1;
const ThreedotsMenuContent$3 = _ref => {
  let {
    handleOnDenounce,
    text,
    url
  } = _ref;
  return /*#__PURE__*/_jsx$k("ul", {
    className: `${NAMESPACE$3}-menu`
  }, void 0, /*#__PURE__*/_jsx$k("li", {
    className: `${NAMESPACE$3}-menu__li`
  }, void 0, /*#__PURE__*/_jsx$k("a", {
    "aria-label": text,
    className: `${NAMESPACE$3}-menu__item-menu`,
    "data-testid": "denounce",
    href: url,
    onClick: handleOnDenounce,
    rel: "noreferrer"
  }, void 0, _FlagIcon || (_FlagIcon = /*#__PURE__*/_jsx$k(FlagIcon, {})), /*#__PURE__*/_jsx$k("span", {}, void 0, text))));
};
ThreedotsMenuContent$3.defaultProps = _objectSpread$e({}, DF_THREEDOTS_MENU_CONTENT);
var threedotsMenuContent = ThreedotsMenuContent$3;
const ThreedotsMenuButton$2 = threedotsMenuButton;
const ThreedotsMenuContent$2 = threedotsMenuContent;
var components = {
  ThreedotsMenuButton: ThreedotsMenuButton$2,
  ThreedotsMenuContent: ThreedotsMenuContent$2
};
const {
  useState: useState$5
} = require$$1;
const {
  NAMESPACE: NAMESPACE$2
} = constants;
const useThreedots$2 = _ref => {
  let {
    onDenounceClick,
    track,
    url
  } = _ref;
  const [isVisibleMenu, setIsVisibleMenu] = useState$5(false);
  const handleOnDenounce = e => {
    if (onDenounceClick) {
      e.preventDefault();
      onDenounceClick(url, track);
    }
    setIsVisibleMenu(false);
  };
  const handleMenu = () => setIsVisibleMenu(prevState => !prevState);
  const getPath = _ref2 => {
    let {
      target
    } = _ref2;
    let currentElem = target;
    const path = [];
    while (currentElem) {
      path.push(currentElem);
      currentElem = currentElem.parentNode;
    }
    return path;
  };
  const handleClickOutside = e => {
    if (!getPath(e).find(el => el.className === `${NAMESPACE$2}-menu__li`)) {
      setIsVisibleMenu(false);
    }
  };
  return {
    isVisibleMenu,
    handleOnDenounce,
    handleMenu,
    handleClickOutside
  };
};
var useThreedots_1 = useThreedots$2;
var _objectSpread$d = require$$0$2.default;
var _jsx$j = require$$0.default;
const Tooltip$1 = require$$9;
const {
  NAMESPACE: NAMESPACE$1
} = constants;
const {
  DF_THREEDOTS_MENU: DF_THREEDOTS_MENU$1,
  PT_THREEDOTS_MENU: PT_THREEDOTS_MENU$1
} = proptypes$5;
const {
  ThreedotsMenuButton: ThreedotsMenuButton$1,
  ThreedotsMenuContent: ThreedotsMenuContent$1
} = components;
const useThreedots$1 = useThreedots_1;
const ThreedotsMenu$1 = _ref => {
  let {
    onDenounceClick,
    text,
    track,
    url
  } = _ref;
  const {
    handleClickOutside,
    handleMenu,
    handleOnDenounce,
    isVisibleMenu
  } = useThreedots$1({
    onDenounceClick,
    track,
    url
  });
  return /*#__PURE__*/_jsx$j("div", {
    className: NAMESPACE$1,
    "data-testid": "denounce-button-contaienr"
  }, void 0, /*#__PURE__*/_jsx$j(Tooltip$1, {
    className: `${NAMESPACE$1}__tooltip`,
    content: /*#__PURE__*/_jsx$j(ThreedotsMenuContent$1, {
      handleOnDenounce: handleOnDenounce,
      text: text,
      url: url
    }),
    onClose: handleClickOutside,
    side: "bottomRight",
    trigger: "no-trigger",
    open: isVisibleMenu
  }, void 0, /*#__PURE__*/_jsx$j(ThreedotsMenuButton$1, {
    handleMenu: handleMenu,
    text: text
  })));
};
ThreedotsMenu$1.defaultProps = _objectSpread$d({}, DF_THREEDOTS_MENU$1);
var threedotsMenu$1 = ThreedotsMenu$1;
const Denounce = threedotsMenu$1;
var threedotsMenu = Denounce;
var _objectSpread$c = require$$0$2.default;
var _jsx$i = require$$0.default;
const BottomSheet$2 = require$$3$1;
const {
  NAMESPACE
} = constants;
const {
  DF_THREEDOTS_MENU,
  PT_THREEDOTS_MENU
} = proptypes$5;
const {
  ThreedotsMenuButton,
  ThreedotsMenuContent
} = components;
const useThreedots = useThreedots_1;
const ThreedotsMenuMobile$1 = _ref => {
  let {
    onDenounceClick,
    text,
    track,
    url
  } = _ref;
  const {
    handleMenu,
    handleOnDenounce,
    isVisibleMenu
  } = useThreedots({
    onDenounceClick,
    track,
    url
  });
  return /*#__PURE__*/_jsx$i("div", {
    className: NAMESPACE
  }, void 0, /*#__PURE__*/_jsx$i(ThreedotsMenuButton, {
    device: "mobile",
    handleMenu: handleMenu,
    text: text
  }), /*#__PURE__*/_jsx$i(BottomSheet$2, {
    initialHeight: "83px",
    open: isVisibleMenu
  }, void 0, /*#__PURE__*/_jsx$i(ThreedotsMenuContent, {
    handleOnDenounce: handleOnDenounce,
    text: text,
    url: url
  })));
};
ThreedotsMenuMobile$1.defaultProps = _objectSpread$c({}, DF_THREEDOTS_MENU);
var threedotsMenu_mobile = ThreedotsMenuMobile$1;
var _objectSpread$b = require$$0$2.default;
const {
  arrayOf: arrayOf$5,
  bool: bool$5,
  func: func$4,
  number: number$5,
  shape: shape$5,
  string: string$5
} = require$$2;
const PT_LIKE_DISLIKE = {
  id: string$5,
  value: number$5,
  text: string$5
};
const PT_VALORIZATIONS_BUTTONS$1 = {
  actions: arrayOf$5(shape$5(_objectSpread$b({}, PT_LIKE_DISLIKE)), shape$5(_objectSpread$b({}, PT_LIKE_DISLIKE))),
  dislikeHref: string$5,
  id: string$5.isRequired,
  islogged: bool$5,
  likeHref: string$5,
  onDenounceClick: func$4.isRequired,
  onDislikeComment: func$4,
  onLikeComment: func$4,
  updateActions: func$4
};
const DF_VALORIZATIONS_BUTTONS$1 = {
  actions: null,
  dislikeHref: '',
  id: '',
  islogged: false,
  likeHref: '',
  onDenounceClick: () => {},
  onDislikeComment: () => {},
  onLikeComment: () => {}
};
var proptypes$4 = {
  PT_VALORIZATIONS_BUTTONS: PT_VALORIZATIONS_BUTTONS$1,
  DF_VALORIZATIONS_BUTTONS: DF_VALORIZATIONS_BUTTONS$1
};
var _objectSpread$a = require$$0$2.default;
var _jsx$h = require$$0.default;
var _LikeIcon;
const React$9 = require$$1;
const Button$3 = require$$3;
const classnames$4 = require$$0$1;
const {
  useState: useState$4,
  useEffect: useEffect$3
} = React$9;
const LikeIcon = like;
const DislikeIcon = dislike;
const LikeFullIcon = likeFull;
const DislikeFullIcon = dislikeFull;
const LikeDisable = likeDisable;
const DislikeDisable = dislikeDisable;
const {
  PT_VALORIZATIONS_BUTTONS,
  DF_VALORIZATIONS_BUTTONS
} = proptypes$4;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$f
} = constants$2;
const namespace$f = `${STYLE_NAMESPACE$f}-valorizations`;
const ValorizationsButtons$3 = _ref => {
  let {
    actions,
    dislikeHref,
    id,
    islogged,
    likeHref,
    onDislikeComment,
    onLikeComment,
    updateActions
  } = _ref;
  const [likes, dislikes] = actions;
  const [stateDisliked, setStateDisliked] = useState$4(dislikes === null || dislikes === void 0 ? void 0 : dislikes.selected);
  const [stateLiked, setStateLiked] = useState$4(likes.selected);
  const [countLikes, setCountLikes] = useState$4(likes.value);
  useEffect$3(() => {
    setCountLikes(likes.value);
    setStateLiked(likes.selected);
  }, [likes]);
  useEffect$3(() => {
    setStateDisliked(dislikes === null || dislikes === void 0 ? void 0 : dislikes.selected);
  }, [dislikes]);
  const handleLikeState = (num, isActive) => {
    if (stateLiked) {
      setCountLikes(countLikes + num);
      setStateLiked(isActive);
    }
  };
  const handleDislikeState = isActive => {
    if (stateDisliked) {
      setStateDisliked(isActive);
    }
  };
  const processLikeEvent = (count, state) => {
    setCountLikes(count);
    setStateLiked(state);
    handleDislikeState(false);
    onLikeComment(id, likes.track, state).then(function () {
      let {
        likes: likesResponse
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const {
        value
      } = likesResponse || {};
      if (value && updateActions) {
        updateActions(value, id, 'LIKE', state);
      }
    });
  };
  const processDislikeEvent = state => {
    setStateDisliked(state);
    handleLikeState(-1, false);
    onDislikeComment(id, dislikes.track, state).then(function () {
      let {
        dislikes: dislikesResponse
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const {
        value
      } = dislikesResponse || {};
      if (value && updateActions) {
        updateActions(value, id, 'DISLIKE', state);
      }
    });
  };
  const handleLikeComment = e => {
    e.preventDefault();
    if (onLikeComment && stateLiked) {
      processLikeEvent(countLikes - 1, false);
    } else processLikeEvent(countLikes + 1, true);
  };
  const handleDislikeComment = e => {
    e.preventDefault();
    if (onDislikeComment && stateDisliked) {
      processDislikeEvent(false);
    } else processDislikeEvent(true);
  };
  return /*#__PURE__*/_jsx$h("div", {
    className: namespace$f
  }, void 0, /*#__PURE__*/_jsx$h(Button$3, {
    "data-testid": "like-button",
    href: likeHref,
    hierarchy: "transparent",
    role: "switch",
    srLabel: `${likes.text} ${countLikes}`,
    "aria-checked": stateLiked,
    className: classnames$4(`${namespace$f}__button`, `${namespace$f}__button-like`, {
      active: stateLiked
    }),
    onClick: handleLikeComment,
    active: "true"
  }, void 0, !stateLiked && /*#__PURE__*/_jsx$h("span", {
    className: `${namespace$f}__button-like__text`
  }, void 0, likes.text), stateLiked && /*#__PURE__*/_jsx$h(LikeFullIcon, {
    className: `${namespace$f}__button-icon`
  }), !stateLiked && islogged && (_LikeIcon || (_LikeIcon = /*#__PURE__*/_jsx$h(LikeIcon, {}))), !stateLiked && !islogged && /*#__PURE__*/_jsx$h(LikeDisable, {
    className: `${namespace$f}__likes__like`
  }), /*#__PURE__*/_jsx$h("p", {
    className: classnames$4({
      [`${namespace$f}__text__disable`]: islogged
    }, `${namespace$f}__button-like__text`)
  }, void 0, countLikes)), dislikes && /*#__PURE__*/_jsx$h(Button$3, {
    "data-testid": "dislike-button",
    href: dislikeHref,
    hierarchy: "transparent",
    role: "switch",
    className: classnames$4(`${namespace$f}__button`, `${namespace$f}__button-dislike`, {
      active: stateDisliked
    }),
    srLabel: `${(dislikes === null || dislikes === void 0 ? void 0 : dislikes.text) || 'No es útil'}`,
    "aria-checked": stateDisliked,
    onClick: handleDislikeComment
  }, void 0, stateDisliked && /*#__PURE__*/_jsx$h(DislikeFullIcon, {
    "data-testid": "dislike",
    className: `${namespace$f}__likes__dislike`
  }), !stateDisliked && islogged && /*#__PURE__*/_jsx$h(DislikeIcon, {
    className: `${namespace$f}__likes__dislike`
  }), !stateDisliked && !islogged && /*#__PURE__*/_jsx$h(DislikeDisable, {
    className: `${namespace$f}__likes__dislike`
  })));
};
ValorizationsButtons$3.defaultProps = _objectSpread$a({}, DF_VALORIZATIONS_BUTTONS);
var valorizationsButtons$1 = ValorizationsButtons$3;
const ValorizationsButtons$2 = valorizationsButtons$1;
var valorizationsButtons = ValorizationsButtons$2;
var image = require$$0$4;
const {
  arrayOf: arrayOf$4,
  func: func$3,
  number: number$4,
  shape: shape$4,
  string: string$4,
  bool: bool$4
} = require$$2;
const PT_CAROUSEL$1 = {
  className: string$4,
  media: arrayOf$4(shape$4({
    alt: string$4,
    rating: number$4 || string$4,
    url: string$4
  })).isRequired,
  onClickImage: func$3,
  overflow: number$4,
  title: shape$4({
    text: string$4
  }),
  type: string$4.isRequired,
  preload: bool$4,
  lazyload: bool$4
};
const DF_CAROUSEL$1 = {
  className: null,
  onClickImage: null,
  overflow: null,
  title: null,
  preload: true,
  lazyload: false
};
const PT_THUMB_RATING$1 = {
  value: number$4.isRequired
};
var proptypes$3 = {
  PT_CAROUSEL: PT_CAROUSEL$1,
  DF_CAROUSEL: DF_CAROUSEL$1,
  PT_THUMB_RATING: PT_THUMB_RATING$1
};
var _objectSpread$9 = require$$0$2.default;
var _jsx$g = require$$0.default;
const Image$1 = image;
const classnames$3 = require$$0$1;
const CarouselSnapped = require$$5;
const IconStarEmpty$1 = starEmpty;
const {
  CarouselSnappedSlide
} = CarouselSnapped;
const {
  PT_CAROUSEL,
  DF_CAROUSEL,
  PT_THUMB_RATING
} = proptypes$3;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$e
} = constants$2;
const namespace$e = `${STYLE_NAMESPACE$e}-carousel`;
const ThumbRating$1 = _ref => {
  let {
    value
  } = _ref;
  return /*#__PURE__*/_jsx$g("div", {
    className: `${namespace$e}__thumb-rating`
  }, void 0, /*#__PURE__*/_jsx$g("span", {}, void 0, value), /*#__PURE__*/_jsx$g(IconStarEmpty$1, {
    className: `${namespace$e}__thumb-rating__star`
  }));
};
const Carousel$2 = _ref2 => {
  let {
    className,
    media,
    onClickImage,
    overflow,
    type,
    preload,
    lazyload
  } = _ref2;
  const isLastItem = index => index === media.length - 1 && overflow;
  const showRate = (index, rate) => !isLastItem(index) && !!rate;
  const handleClickImage = (urlNavigation, track) => {
    onClickImage(urlNavigation, track);
  };
  const slidesPerView = type === 'primary' ? 4 : 5;
  const carouselTypeClassName = `reviews-carousel-${type}`;
  const arrowsConfig = {
    size: 'small'
  };
  return /*#__PURE__*/_jsx$g(CarouselSnapped, {
    srLabel: "Fotos review",
    arrows: arrowsConfig,
    className: classnames$3(namespace$e, className, carouselTypeClassName, {
      [`${namespace$e}__disabled-swipe`]: (media === null || media === void 0 ? void 0 : media.length) <= slidesPerView
    }),
    pagination: false,
    slidesPerView: slidesPerView,
    strictBoundaries: false
  }, void 0, media.map((elem, index) => /*#__PURE__*/_jsx$g(CarouselSnappedSlide, {
    className: classnames$3(carouselTypeClassName, `${namespace$e}__carousel-slide`)
  }, `photo-review-${type}-${index}`, /*#__PURE__*/_jsx$g("div", {
    className: classnames$3(`${namespace$e}__img-container`, carouselTypeClassName)
  }, void 0, showRate(index, elem.rating) && /*#__PURE__*/_jsx$g("div", {
    className: `${namespace$e}__overlay-container`
  }, void 0, /*#__PURE__*/_jsx$g("div", {
    className: `${namespace$e}__img-overlay`
  }), /*#__PURE__*/_jsx$g(ThumbRating$1, {
    value: elem.rating
  })), /*#__PURE__*/_jsx$g(Image$1, {
    alt: "",
    src: elem.url,
    preload: preload,
    lazyload: lazyload ? 'on' : 'off',
    className: `${namespace$e}__img`,
    "data-testid": `img-carousel-${index}`,
    onClick: () => {
      handleClickImage(elem.url_navigation, elem.track);
    }
  }), overflow && isLastItem(index) && /*#__PURE__*/_jsx$g("div", {
    className: `${namespace$e}__overlay-container`
  }, void 0, /*#__PURE__*/_jsx$g("div", {
    className: `${namespace$e}__img-overlay`
  }), /*#__PURE__*/_jsx$g("span", {
    className: `${namespace$e}__overflow`
  }, void 0, `+${overflow}`))))));
};
Carousel$2.defaultProps = _objectSpread$9({}, DF_CAROUSEL);
var carousel = Carousel$2;
const {
  arrayOf: arrayOf$3,
  func: func$2,
  number: number$3,
  shape: shape$3,
  string: string$3,
  bool: bool$3
} = require$$2;
const PT_CAROUSEL_MOBILE$1 = {
  className: string$3,
  media: arrayOf$3(shape$3({
    alt: string$3,
    rating: number$3 || string$3,
    url: string$3
  })).isRequired,
  onClickImage: func$2,
  overflow: number$3,
  title: shape$3({
    text: string$3
  }),
  type: string$3.isRequired,
  preload: bool$3,
  lazyload: bool$3
};
const DF_CAROUSEL_MOBILE$1 = {
  className: null,
  onClickImage: null,
  overflow: null,
  title: null,
  preload: true,
  lazyload: false
};
const PT_THUMB_RATING_MOBILE$1 = {
  value: number$3.isRequired
};
var proptypes$2 = {
  PT_CAROUSEL_MOBILE: PT_CAROUSEL_MOBILE$1,
  DF_CAROUSEL_MOBILE: DF_CAROUSEL_MOBILE$1,
  PT_THUMB_RATING_MOBILE: PT_THUMB_RATING_MOBILE$1
};
var _objectSpread$8 = require$$0$2.default;
var _jsx$f = require$$0.default;
const Image = image;
const classnames$2 = require$$0$1;
const CarouselFree = require$$5$1;
const IconStarEmpty = starEmpty;
const {
  CarouselFreeSlide
} = CarouselFree;
const {
  PT_CAROUSEL_MOBILE,
  DF_CAROUSEL_MOBILE,
  PT_THUMB_RATING_MOBILE
} = proptypes$2;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$d
} = constants$2;
const namespace$d = `${STYLE_NAMESPACE$d}-carousel-mobile`;
const ThumbRating = _ref => {
  let {
    value
  } = _ref;
  return /*#__PURE__*/_jsx$f("div", {
    className: `${namespace$d}__thumb-rating`
  }, void 0, /*#__PURE__*/_jsx$f("span", {}, void 0, value), /*#__PURE__*/_jsx$f(IconStarEmpty, {
    className: `${namespace$d}__thumb-rating__star`
  }));
};
const CarouselMobile$1 = _ref2 => {
  let {
    className,
    media,
    onClickImage,
    overflow,
    type,
    preload,
    lazyload
  } = _ref2;
  const isLastItem = index => index === media.length - 1 && overflow;
  const showRate = (index, rate) => !isLastItem(index) && !!rate;
  const spacing = type === 'primary' ? 8 : 6;
  const carouselTypeClassName = `reviews-carousel-${type}`;
  const handleClickImage = (urlNavigation, track) => {
    onClickImage(urlNavigation, track);
  };
  return /*#__PURE__*/_jsx$f(CarouselFree, {
    srLabel: "Fotos review",
    spacing: spacing,
    className: classnames$2(namespace$d, className, carouselTypeClassName)
  }, void 0, media.map((elem, index) => /*#__PURE__*/_jsx$f(CarouselFreeSlide, {
    className: carouselTypeClassName
  }, `photo-review-${type}-${index}`, /*#__PURE__*/_jsx$f("div", {
    className: classnames$2(`${namespace$d}__img-container`, carouselTypeClassName)
  }, void 0, showRate(index, elem.rating) && /*#__PURE__*/_jsx$f("div", {
    className: `${namespace$d}__overlay-container`
  }, void 0, /*#__PURE__*/_jsx$f("div", {
    className: `${namespace$d}__img-overlay`
  }), /*#__PURE__*/_jsx$f(ThumbRating, {
    value: elem.rating
  })), /*#__PURE__*/_jsx$f(Image, {
    alt: "",
    src: elem.url,
    preload: preload,
    lazyload: lazyload ? 'on' : 'off',
    className: `${namespace$d}__img`,
    "data-testid": `img-carousel-${index}`,
    onClick: () => {
      handleClickImage(elem.url_navigation, elem.track);
    }
  }), overflow && isLastItem(index) && /*#__PURE__*/_jsx$f("div", {
    className: `${namespace$d}__overlay-container`
  }, void 0, /*#__PURE__*/_jsx$f("div", {
    className: `${namespace$d}__img-overlay`
  }), /*#__PURE__*/_jsx$f("span", {
    className: `${namespace$d}__overflow`
  }, void 0, `+${overflow}`))))));
};
CarouselMobile$1.defaultProps = _objectSpread$8({}, DF_CAROUSEL_MOBILE);
var carouselMobile = CarouselMobile$1;
var _extends$6 = require$$0$3.default;
var _jsx$e = require$$0.default;
var _objectSpread$7 = require$$0$2.default;
const React$8 = require$$1;
const classname = require$$0$1;
const StyleLabel$1 = styleLabel;
const Stars = stars;
const CommentContent = commentContent;
const ThreedotsMenu = threedotsMenu;
const ThreedotsMenuMobile = threedotsMenu_mobile;
const ValorizationsButtons$1 = valorizationsButtons;
const Carousel$1 = carousel;
const CarouselMobile = carouselMobile;
const {
  PT_COMMENT,
  DF_COMMENT
} = proptypes$6;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$c
} = constants$2;
const namespace$c = `${STYLE_NAMESPACE$c}-comments__comment`;
const Comment$2 = _ref => {
  let {
    actions,
    carousel,
    className,
    comment,
    dislikeHref,
    gallery,
    id,
    isCarouselComment,
    islogged,
    likeHref,
    mobile,
    onClickCarouselImage,
    onDenounceClick,
    onDislikeComment,
    onLikeComment,
    rating,
    aria_label,
    updateActions,
    variant,
    vpp,
    official_store_label
  } = _ref;
  const carouselProps = carousel ? _objectSpread$7(_objectSpread$7({}, carousel), {}, {
    preload: !vpp,
    lazyload: vpp
  }) : carousel;
  return /*#__PURE__*/React$8.createElement(React$8.Fragment, null, /*#__PURE__*/_jsx$e("article", {
    "aria-roledescription": "Review",
    className: classname(namespace$c, className),
    "data-testid": "comment-component"
  }, void 0, /*#__PURE__*/_jsx$e("div", {
    className: classname(`${namespace$c}__header`)
  }, void 0, /*#__PURE__*/_jsx$e("div", {
    className: classname(`${namespace$c}__rating-container`)
  }, void 0, /*#__PURE__*/_jsx$e(Stars, {
    "aria-hidden": "true",
    className: `${namespace$c}__rating`,
    value: rating,
    aria_label: aria_label
  }), comment.date && !isCarouselComment && /*#__PURE__*/_jsx$e("span", {
    className: `${namespace$c}__date`
  }, void 0, comment.date)), official_store_label && /*#__PURE__*/_jsx$e("span", {
    className: `${namespace$c}__official_store_label`
  }, void 0, /*#__PURE__*/React$8.createElement(StyleLabel$1, official_store_label)), variant && /*#__PURE__*/_jsx$e("span", {
    className: `${namespace$c}__subtitle`
  }, void 0, variant)), carousel && carousel.media.length >= 1 && /*#__PURE__*/_jsx$e("div", {
    className: mobile ? `${namespace$c}__carousel--secondary-mobile` : `${namespace$c}__carousel--secondary`
  }, void 0, mobile ? /*#__PURE__*/React$8.createElement(CarouselMobile, _extends$6({}, carouselProps, {
    onClickImage: onClickCarouselImage
  })) : /*#__PURE__*/React$8.createElement(Carousel$1, _extends$6({}, carouselProps, {
    onClickImage: onClickCarouselImage
  }))), /*#__PURE__*/_jsx$e(CommentContent, {
    content: comment.content,
    mobile: mobile,
    date: comment.date,
    gallery: gallery,
    vpp: vpp
  }), !gallery && comment.date && isCarouselComment && /*#__PURE__*/_jsx$e("span", {
    className: `${namespace$c}__date`
  }, void 0, comment.date), /*#__PURE__*/_jsx$e("div", {
    className: `${namespace$c}__footer`
  }, void 0, actions && /*#__PURE__*/_jsx$e(ValorizationsButtons$1, {
    actions: actions,
    islogged: islogged,
    likeHref: likeHref,
    dislikeHref: dislikeHref,
    id: id,
    onLikeComment: onLikeComment,
    onDislikeComment: onDislikeComment,
    updateActions: updateActions
  }), comment.denounce && (!mobile ? /*#__PURE__*/React$8.createElement(ThreedotsMenu, _extends$6({}, comment.denounce, {
    onDenounceClick: onDenounceClick
  })) : /*#__PURE__*/React$8.createElement(ThreedotsMenuMobile, _extends$6({}, comment.denounce, {
    onDenounceClick: onDenounceClick
  }))))));
};
Comment$2.defaultProps = _objectSpread$7({}, DF_COMMENT);
var comment$1 = React$8.memo(Comment$2);
const Comment$1 = comment$1;
var comment = Comment$1;
const {
  arrayOf: arrayOf$2,
  bool: bool$2,
  func: func$1,
  number: number$2,
  shape: shape$2,
  string: string$2,
  oneOfType
} = require$$2;
const PT_COMMENTS$1 = {
  embedded: bool$2,
  islogged: bool$2,
  message: shape$2({
    subtitle: string$2,
    title: string$2
  }),
  mobile: bool$2,
  offset: oneOfType([number$2, string$2]),
  onClickCarouselImage: func$1,
  onDenounceClick: func$1,
  onDislikeComment: func$1,
  onLikeComment: func$1,
  OnOffset: func$1,
  onScrollTab: func$1,
  orderCriteria: string$2,
  rating: string$2,
  reviews: arrayOf$2(shape$2({
    actions: arrayOf$2(shape$2({})),
    aria_label: string$2,
    comment: shape$2({}),
    id: string$2,
    onDenounceClick: func$1,
    rating: number$2,
    variants: string$2
  })).isRequired,
  vpp: bool$2
};
const DF_COMMENTS$1 = {
  embedded: false,
  islogged: false,
  message: null,
  mobile: true,
  onDenounceClick: () => {},
  onDislikeComment: () => {},
  onLikeComment: () => {},
  OnOffset: () => {},
  onScrollTab: () => {},
  orderCriteria: '',
  rating: ''
};
var proptypes$1 = {
  PT_COMMENTS: PT_COMMENTS$1,
  DF_COMMENTS: DF_COMMENTS$1
};
const React$7 = require$$1;
function componentFactoryFrom$1(sources) {
  function ComponentFactory(data) {
    const source = sources[data.id];
    if (!source) return null;
    const props = data;
    return React$7.createElement(source, props);
  }
  return ComponentFactory;
}
var componentFactory = componentFactoryFrom$1;
var _jsx$d = require$$0.default;
const {
  Title: Title$3
} = require$$2$1;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$b
} = constants$2;
const namespace$b = `${STYLE_NAMESPACE$b}__summary__sections`;
// TODO: replace ul with TextList when Andes version reach version 8 (typography do not have list on v7)

const BULLET_POINT = '•';
const Sections = _ref => {
  let {
    sections
  } = _ref;
  return /*#__PURE__*/_jsx$d("div", {
    className: namespace$b
  }, void 0, sections && sections.map((section, index) => /*#__PURE__*/_jsx$d("div", {
    className: `${namespace$b}__container`
  }, index, section.title.text && /*#__PURE__*/_jsx$d(Title$3, {
    className: `${namespace$b}__title`,
    color: "primary",
    component: "h2",
    size: "xs"
  }, void 0, section.title.text), /*#__PURE__*/_jsx$d("ul", {
    className: `${namespace$b}__bullets`
  }, void 0, section.bullets.map((bullet, bulletIndex) => /*#__PURE__*/_jsx$d("li", {
    className: `${namespace$b}__item`
  }, bulletIndex, /*#__PURE__*/_jsx$d("span", {
    className: `${namespace$b}__bullet-point`
  }, void 0, BULLET_POINT), /*#__PURE__*/_jsx$d("span", {
    className: `${namespace$b}__bullet-text`
  }, void 0, bullet.text)))))));
};
var sections = Sections;
var _jsx$c = require$$0.default;
const {
  Title: Title$2
} = require$$2$1;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$a
} = constants$2;
const namespace$a = `${STYLE_NAMESPACE$a}__summary__plain_text`;
const Summary$3 = _ref => {
  let {
    summary_title,
    summary_text
  } = _ref;
  return /*#__PURE__*/_jsx$c("div", {
    className: namespace$a
  }, void 0, summary_title.text && /*#__PURE__*/_jsx$c(Title$2, {
    className: `${namespace$a}__title`,
    color: "primary",
    component: "h2",
    size: "16px"
  }, void 0, summary_title.text), /*#__PURE__*/_jsx$c("p", {
    className: `${namespace$a}__summary_container`
  }, void 0, summary_text.text));
};
Summary$3.defaultProps = {
  summary_title: {
    text: ''
  },
  summary_text: {
    text: ''
  }
};
var summary$1 = Summary$3;
var _jsx$b = require$$0.default;
var _path, _rect;
const IconAi = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx$b("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, void 0, _path || (_path = /*#__PURE__*/_jsx$b("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.24055 1.46224C8.84928 0.746962 7.82196 0.746961 7.43068 1.46224L5.7212 4.58728C5.62653 4.76035 5.48422 4.90264 5.31114 4.99728L2.18593 6.70618C1.47045 7.09741 1.47045 8.12498 2.18593 8.51621L5.31114 10.2251C5.48422 10.3198 5.62653 10.462 5.7212 10.6351L7.43068 13.7601C7.82196 14.4754 8.84928 14.4754 9.24055 13.7601L10.95 10.6351C11.0447 10.462 11.187 10.3198 11.3601 10.2251L14.4853 8.51621C15.2008 8.12498 15.2008 7.09741 14.4853 6.70618L11.3601 4.99728C11.187 4.90264 11.0447 4.76035 10.95 4.58728L9.24055 1.46224ZM8.67451 6.26099C8.48727 6.07379 8.18369 6.07379 7.99644 6.26099L6.98501 7.27223C6.79776 7.45944 6.79776 7.76296 6.98501 7.95017L7.99644 8.9614C8.18369 9.14861 8.48727 9.14861 8.67451 8.9614L9.68594 7.95017C9.87319 7.76296 9.87319 7.45944 9.68594 7.27223L8.67451 6.26099Z",
    fill: "#3483FA"
  })), _rect || (_rect = /*#__PURE__*/_jsx$b("rect", {
    x: "2.93832",
    y: "10.9688",
    width: "2.87652",
    height: "2.87652",
    rx: "0.359565",
    transform: "rotate(45 2.93832 10.9688)",
    fill: "#3483FA"
  })));
};
IconAi.defaultProps = {
  className: ''
};
var artificialIntelligence = IconAi;
var _jsx$a = require$$0.default;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$9
} = constants$2;
const ROBOT_ICON_ID = 'robot_ai_icon';
const IconAI = artificialIntelligence;
const namespace$9 = `${STYLE_NAMESPACE$9}__summary__description`;
const renderIcon = _ref => {
  let {
    id
  } = _ref;
  switch (id) {
    case ROBOT_ICON_ID:
      return /*#__PURE__*/_jsx$a(IconAI, {
        className: `${namespace$9}__icon`
      });
    default:
      return null;
  }
};
const SummaryDescription = _ref2 => {
  let {
    icon,
    text
  } = _ref2;
  return /*#__PURE__*/_jsx$a("div", {
    className: namespace$9
  }, void 0, icon && renderIcon(icon), /*#__PURE__*/_jsx$a("span", {
    className: `${namespace$9}__text`
  }, void 0, text));
};
var description = SummaryDescription;
var _jsx$9 = require$$0.default;
// const { useState, useEffect, useRef, useMemo } = require('react');
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$8
} = constants$2;
const ValorizationsButtons = valorizationsButtons;
const namespace$8 = `${STYLE_NAMESPACE$8}__summary__valorization-buttons`;
// TODO - Create a new component for this
const SummaryActions = _ref => {
  let {
    summaryId,
    actions,
    islogged,
    onDislikeSummary,
    onLikeSummary
  } = _ref;
  return /*#__PURE__*/_jsx$9("div", {
    className: namespace$8
  }, void 0, actions && /*#__PURE__*/_jsx$9(ValorizationsButtons, {
    actions: actions,
    islogged: islogged,
    id: summaryId,
    onLikeComment: onLikeSummary,
    onDislikeComment: onDislikeSummary
  }));
};
var actions = SummaryActions;

/* eslint-disable security/detect-object-injection */

const componentFactoryFrom = componentFactory;
const sources = {};
const SECTIONS = 'SECTIONS';
const SUMMARY_DESCRIPTION = 'SUMMARY_DESCRIPTION';
const SUMMARY = 'SUMMARY';
const ACTIONS = 'SUMMARY_ACTIONS';
sources[SECTIONS] = sections;
sources[SUMMARY] = summary$1;
sources[SUMMARY_DESCRIPTION] = description;
sources[ACTIONS] = actions;
const ComponentFactory$1 = componentFactoryFrom(sources);
var factoryComponents = ComponentFactory$1;
var _jsx$8 = require$$0.default;
var _extends$5 = require$$0$3.default;
/* eslint-disable react/prop-types */

const React$6 = require$$1;
const ComponentFactory = factoryComponents;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$7
} = constants$2;
const namespace$7 = `${STYLE_NAMESPACE$7}__summary`;
const Summary$2 = summary => {
  const {
    summary_id,
    object_id,
    components,
    isLogged,
    onLikeSummary,
    onDislikeSummary
  } = summary;
  return !components || components.length === 0 ? null : /*#__PURE__*/_jsx$8("div", {
    className: namespace$7,
    "data-testid": "summary-component"
  }, void 0, components && components.map((component, index) => /*#__PURE__*/React$6.createElement(ComponentFactory, _extends$5({
    key: index,
    summaryId: summary_id,
    objectId: object_id,
    isLogged: isLogged,
    onLikeSummary: onLikeSummary,
    onDislikeSummary: onDislikeSummary
  }, component))));
};
Summary$2.defaultProps = {
  summary: {},
  id: null,
  item_id: '',
  components: []
};
var summary = Summary$2;
var _jsx$7 = require$$0.default;
var _EmptyMessageIcon;
const classNames$2 = require$$0$1;
const EmptyMessageIcon = emptyMessages$1;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$6
} = constants$2;
const namespace$6 = `${STYLE_NAMESPACE$6}-empty-messages`;
const EmptyState = _ref => {
  let {
    id,
    title,
    label,
    className
  } = _ref;
  const componentClassNames = classNames$2(namespace$6, className);
  return /*#__PURE__*/_jsx$7("div", {
    className: componentClassNames,
    id: id,
    "data-testid": "empty-messages"
  }, void 0, /*#__PURE__*/_jsx$7("div", {
    className: "ui-reviews-empty-state--wrapper"
  }, void 0, _EmptyMessageIcon || (_EmptyMessageIcon = /*#__PURE__*/_jsx$7(EmptyMessageIcon, {
    aria_hidden: true
  })), /*#__PURE__*/_jsx$7("div", {
    className: "ui-reviews-empty-state--title"
  }, void 0, /*#__PURE__*/_jsx$7("h3", {
    class: "ui-reviews-label"
  }, void 0, title.text)), /*#__PURE__*/_jsx$7("div", {
    className: "ui-reviews-empty-state--description"
  }, void 0, /*#__PURE__*/_jsx$7("p", {
    class: "ui-reviews-label"
  }, void 0, label.text))));
};
EmptyState.defaultProps = {
  className: ''
};
var emptyMessages = EmptyState;
var _objectSpread$6 = require$$0$2.default;
var _extends$4 = require$$0$3.default;
var _jsx$6 = require$$0.default;
/* eslint-disable no-restricted-syntax */
const React$5 = require$$1;
const {
  useState: useState$3,
  useEffect: useEffect$2,
  useRef,
  useCallback
} = React$5;
const {
  Title: Title$1
} = require$$2$1;
const Comment = comment;
const {
  PT_COMMENTS,
  DF_COMMENTS
} = proptypes$1;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$5
} = constants$2;
const Summary$1 = summary;
const namespace$5 = `${STYLE_NAMESPACE$5}-comments`;
const options = {
  root: null,
  rootMargin: '100px',
  threshold: 0.2
};
const EmptyMessages = emptyMessages;
const Comments$2 = _ref => {
  let {
    embedded,
    islogged,
    message,
    mobile,
    offset,
    onClickCarouselImage,
    onDenounceClick,
    onDislikeComment,
    onDislikeSummary,
    onLikeComment,
    onLikeSummary,
    OnOffset,
    onScrollTab,
    orderCriteria,
    rating,
    officialStore,
    reviews,
    vpp,
    summary,
    title_reviews,
    total_comments,
    empty_messages,
    total_opinions
  } = _ref;
  const observer = useRef(null);
  const [comments, setComments] = useState$3(reviews);
  const [isHasMore, setIsHasMore] = useState$3(true);
  const [isLoading, setIsLoading] = useState$3(false);
  const [isFetching, setFetching] = useState$3(false);
  const hasComments = total_comments !== 0;
  useEffect$2(() => {
    if (reviews) {
      setComments(reviews);
      setIsHasMore(true);
    } else {
      setComments([]);
    }
  }, [reviews, embedded]);
  const lastComment = useCallback(node => {
    const fetchData = async () => {
      if (onScrollTab && !embedded && !vpp) {
        try {
          setFetching(true);
          const params = {
            rating,
            orderCriteria,
            officialStore,
            offset
          };
          const response = await onScrollTab(params);
          if (response.reviews && response.reviews.length < 1) {
            setIsHasMore(false);
          }
          setComments(arr => [...arr, ...(response === null || response === void 0 ? void 0 : response.reviews)]);
          OnOffset();
          setIsLoading(false);
        } catch (error) {
          setIsHasMore(false);
          setIsLoading(false);
        }
      } else {
        onScrollTab();
      }
    };
    if (!node) {
      return;
    }
    if (!isHasMore) {
      return;
    }
    if (isLoading) {
      return;
    }
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setIsLoading(true);
        fetchData();
      }
    }, options);
    if (node) observer.current.observe(node);
  }, [rating, orderCriteria, offset, onScrollTab, officialStore, OnOffset, vpp, embedded, isHasMore, isLoading]);
  return /*#__PURE__*/React$5.createElement(React$5.Fragment, null, hasComments && /*#__PURE__*/React$5.createElement(React$5.Fragment, null, /*#__PURE__*/_jsx$6(Title$1, {
    className: `${namespace$5}__title`,
    color: "primary",
    component: "h2",
    size: "16px"
  }, void 0, title_reviews && title_reviews.title), !mobile && /*#__PURE__*/_jsx$6("span", {
    className: "total-opinion"
  }, void 0, total_opinions), summary && /*#__PURE__*/React$5.createElement(Summary$1, _extends$4({
    onLikeSummary: onLikeSummary,
    onDislikeSummary: onDislikeSummary,
    islogged: islogged
  }, summary))), /*#__PURE__*/_jsx$6("div", {
    className: namespace$5,
    "data-testid": "comments-component"
  }, void 0, comments.length > 0 && hasComments && comments.map((comment, index) => /*#__PURE__*/React$5.createElement("div", {
    key: `${index}-${comment.id}`,
    ref: index === comments.length - 1 ? lastComment : null
  }, /*#__PURE__*/React$5.createElement(Comment, _extends$4({}, comment, {
    islogged: islogged,
    mobile: mobile,
    onLikeComment: onLikeComment,
    onDislikeComment: onDislikeComment,
    onDenounceClick: onDenounceClick,
    onClickCarouselImage: onClickCarouselImage,
    vpp: vpp
  })))), !hasComments && empty_messages && /*#__PURE__*/React$5.createElement(EmptyMessages, empty_messages), message && !isFetching && /*#__PURE__*/_jsx$6("div", {
    className: `${namespace$5}__no-reviews`
  }, void 0, /*#__PURE__*/_jsx$6("h3", {
    className: `${namespace$5}__no-reviews__title`
  }, void 0, message === null || message === void 0 ? void 0 : message.title), /*#__PURE__*/_jsx$6("h3", {
    className: `${namespace$5}__no-reviews__subtitle`
  }, void 0, message === null || message === void 0 ? void 0 : message.subtitle))));
};
Comments$2.defaultProps = _objectSpread$6({}, DF_COMMENTS);
var comments$1 = Comments$2;
const Comments$1 = comments$1;
var comments = Comments$1;
var _objectSpread$5 = require$$0$2.default;
var _jsx$5 = require$$0.default;
var _extends$3 = require$$0$3.default;
const React$4 = require$$1;
const {
  Switch
} = require$$4$1;
const StyleLabel = styleLabel;
const {
  PT_SWITCH_FILTER,
  DP_SWITCH_FILTER
} = proptypes$7;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$4
} = constants$2;
const namespace$4 = `${STYLE_NAMESPACE$4}-switch-filter`;
const SwitchFilter$1 = _ref => {
  let {
    onFilter,
    value,
    title,
    inline,
    track,
    official_store_id
  } = _ref;
  const labelText = /*#__PURE__*/React$4.createElement(StyleLabel, _extends$3({}, title, {
    class_name: `${namespace$4}__label`
  }));
  return /*#__PURE__*/_jsx$5("div", {
    className: `${namespace$4}`,
    "data-testid": "switch-filter"
  }, void 0, /*#__PURE__*/_jsx$5(Switch, {
    defaultChecked: value,
    className: `${namespace$4}__switch`,
    label: labelText,
    labelPosition: "left",
    srLabel: title.text,
    checked: value,
    onChange: ev => {
      onFilter({
        value: ev.target.checked ? official_store_id : false,
        inline,
        track
      });
    }
  }));
};
SwitchFilter$1.defaultProps = _objectSpread$5({}, DP_SWITCH_FILTER);
var switchFilter = SwitchFilter$1;
var _extends$2 = require$$0$3.default;
var _jsx$4 = require$$0.default;
var _objectSpread$4 = require$$0$2.default;
var _FilterIcon, _StarFull;
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
const React$3 = require$$1;
const {
  useState: useState$2,
  useEffect: useEffect$1
} = React$3;
const {
  Button: Button$2
} = require$$3;
const BottomSheet$1 = require$$3$1;
const classnames$1 = require$$0$1;
const {
  Title
} = require$$2$1;
const SwitchFilter = switchFilter;
const StarFull = starFull;
const FilterIcon = filterIcon;
const {
  PT_FILTER_BOTTOM_SHEET,
  DF_FILTER_BOTTOM_SHEET
} = proptypes$7;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$3
} = constants$2;
const namespace$3 = `${STYLE_NAMESPACE$3}-comments`;
const FilterBottomSheet$1 = _ref => {
  var _order_by$items, _qualification$items;
  let {
    button_text,
    clean_filters,
    internal_title,
    itemValueVpp,
    official_store_filter,
    onCleanFilters,
    onFilter,
    order_by,
    qualification,
    title,
    total_opinions,
    vpp,
    title_reviews,
    should_hide_button_all_reviews,
    inline_official_store_filter
  } = _ref;
  const ALL = 'all';
  const [isOpen, setIsOpen] = useState$2(false);
  const [itemFilters, setItemFilters] = useState$2({
    orderCriteria: itemValueVpp.orderCriteria || null,
    rating: itemValueVpp.rating || null,
    officialStore: itemValueVpp.officialStore || null
  });
  const [mobileTracks, setMobileTracks] = useState$2({
    orderCriteria: null,
    rating: null,
    officialStore: null
  });
  const [filteredTO, setFilteredTO] = useState$2();
  useEffect$1(() => {
    if ((filteredTO === false || filteredTO === null) && itemFilters.officialStore !== null) {
      setFilteredTO(false);
    } else {
      setFilteredTO(itemFilters.officialStore);
    }
  }, [filteredTO, itemFilters.officialStore]);
  const lengthFilters = Object.values(itemFilters).filter(val => val).length;
  const handleClickClose = () => {
    setIsOpen(!isOpen);
  };
  const handleApplyFilters = () => {
    onFilter(_objectSpread$4(_objectSpread$4({}, itemFilters), {}, {
      rating: itemFilters.rating === ALL ? null : itemFilters.rating,
      officialStore: itemFilters.officialStore === ALL ? null : itemFilters.officialStore
    }), mobileTracks);
    setFilteredTO(itemFilters.officialStore !== ALL);
    if (itemFilters.officialStore === ALL) {
      setItemFilters(prevOffset => _objectSpread$4(_objectSpread$4({}, prevOffset), {}, {
        officialStore: null
      }));
      setMobileTracks(prevOffset => _objectSpread$4(_objectSpread$4({}, prevOffset), {}, {
        officialStore: null
      }));
    }
    handleClickClose();
  };
  const handleResetFilters = () => {
    if (!vpp) {
      onCleanFilters();
    }
    onFilter(_objectSpread$4(_objectSpread$4({}, itemFilters), {}, {
      rating: null,
      orderCriteria: null,
      officialStore: null
    }), mobileTracks);
    setItemFilters(prevOffset => _objectSpread$4(_objectSpread$4({}, prevOffset), {}, {
      orderCriteria: null,
      rating: null,
      officialStore: null
    }));
    setMobileTracks(prevOffset => _objectSpread$4(_objectSpread$4({}, prevOffset), {}, {
      orderCriteria: null,
      rating: null,
      officialStore: null
    }));
    setFilteredTO(false);
    handleClickClose();
  };
  const handleSelectFilter = (value, keyObject, track) => {
    setItemFilters(prevOffset => _objectSpread$4(_objectSpread$4({}, prevOffset), {}, {
      [keyObject]: value
    }));
    setMobileTracks(prevOffset => _objectSpread$4(_objectSpread$4({}, prevOffset), {}, {
      [keyObject]: track
    }));
  };
  const filterSwichTO = _ref2 => {
    let {
      value,
      inline,
      track
    } = _ref2;
    const defaultValue = inline ? null : ALL;
    const isValuePresent = Boolean(value);
    handleSelectFilter(value || defaultValue, 'officialStore', isValuePresent ? track : null);
    if (inline) {
      setFilteredTO(isValuePresent);
      onFilter(_objectSpread$4(_objectSpread$4({}, itemFilters), {}, {
        rating: itemFilters.rating === ALL ? null : itemFilters.rating,
        officialStore: value || null
      }), _objectSpread$4(_objectSpread$4({}, mobileTracks), {}, {
        officialStore: isValuePresent ? track : null
      }));
    }
  };
  return /*#__PURE__*/_jsx$4("div", {
    className: classnames$1(namespace$3, `${namespace$3}__filters`),
    "data-testid": "comments-component"
  }, void 0, /*#__PURE__*/_jsx$4("span", {
    className: "total-opinion"
  }, void 0, total_opinions), /*#__PURE__*/_jsx$4(Title, {
    className: `${namespace$3}__title-comments`,
    color: "primary",
    component: "h2",
    size: "16px"
  }, void 0, title_reviews && title_reviews.title), /*#__PURE__*/_jsx$4("div", {
    className: classnames$1(`${namespace$3}__filter-container`, {
      [`${namespace$3}__filter-container--space`]: should_hide_button_all_reviews
    })
  }, void 0, !should_hide_button_all_reviews && /*#__PURE__*/_jsx$4(Button$2, {
    onClick: handleClickClose,
    "data-testid": "filter",
    className: `${namespace$3}__filter`,
    size: "medium",
    srLabel: title,
    role: "button",
    hierarchy: "quiet"
  }, void 0, _FilterIcon || (_FilterIcon = /*#__PURE__*/_jsx$4(FilterIcon, {})), title, lengthFilters > 0 && !vpp && /*#__PURE__*/_jsx$4("span", {
    className: `${namespace$3}__spacing`
  }, void 0, " (", lengthFilters, ")"))), inline_official_store_filter && /*#__PURE__*/React$3.createElement(React$3.Fragment, null, /*#__PURE__*/React$3.createElement(SwitchFilter, _extends$2({}, inline_official_store_filter, {
    value: filteredTO,
    inline: true,
    onFilter: filterSwichTO
  })), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__divider ${namespace$3}__divider-visible mt-8`
  })), /*#__PURE__*/_jsx$4(BottomSheet$1, {
    open: isOpen,
    initialHeight: official_store_filter ? '510px' : '450px'
  }, void 0, /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__title-container`
  }, void 0, /*#__PURE__*/_jsx$4("h3", {
    className: `${namespace$3}__buttomsheet-title`
  }, void 0, internal_title), lengthFilters > 0 && /*#__PURE__*/_jsx$4(Button$2, {
    "data-testid": "close",
    className: `${namespace$3}__restore-filters`,
    size: "medium",
    srLabel: "Cerrar",
    role: "button",
    hierarchy: "transparent",
    onClick: handleResetFilters
  }, void 0, clean_filters)), official_store_filter && /*#__PURE__*/React$3.createElement(React$3.Fragment, null, /*#__PURE__*/React$3.createElement(SwitchFilter, _extends$2({}, official_store_filter, {
    value: itemFilters.officialStore && itemFilters.officialStore !== ALL,
    inline: false,
    onFilter: filterSwichTO
  })), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__divider mt-12`
  })), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__content-container`
  }, void 0, /*#__PURE__*/_jsx$4("span", {}, void 0, order_by === null || order_by === void 0 ? void 0 : order_by.title), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__pill-container`
  }, void 0, order_by === null || order_by === void 0 || (_order_by$items = order_by.items) === null || _order_by$items === void 0 ? void 0 : _order_by$items.map((_ref3, index) => {
    let {
      text,
      value,
      track
    } = _ref3;
    return /*#__PURE__*/_jsx$4("div", {
      className: classnames$1(`${namespace$3}__tag-filter`, {
        [`${namespace$3}__tag-filter--active`]: itemFilters.orderCriteria === value
      }),
      onClick: handleSelectFilter.bind(undefined, value, 'orderCriteria', track)
    }, `${namespace$3}__tag-filter-${index}`, text);
  }))), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__divider`
  }), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__content-container`
  }, void 0, /*#__PURE__*/_jsx$4("span", {}, void 0, qualification === null || qualification === void 0 ? void 0 : qualification.title), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__pill-container`
  }, void 0, qualification === null || qualification === void 0 || (_qualification$items = qualification.items) === null || _qualification$items === void 0 ? void 0 : _qualification$items.map((_ref4, index) => {
    let {
      text,
      value,
      track
    } = _ref4;
    return /*#__PURE__*/_jsx$4("div", {
      className: classnames$1(`${namespace$3}__tag-filter`, {
        [`${namespace$3}__tag-filter--active`]: itemFilters.rating === value
      }),
      onClick: handleSelectFilter.bind(undefined, value, 'rating', track)
    }, `${namespace$3}__tag-filter-${index}`, text, value !== ALL && (_StarFull || (_StarFull = /*#__PURE__*/_jsx$4(StarFull, {}))));
  }))), /*#__PURE__*/_jsx$4("div", {
    className: `${namespace$3}__apply-filters`
  }, void 0, /*#__PURE__*/_jsx$4(Button$2, {
    "data-testid": "close",
    className: `${namespace$3}__apply-filter-btn`,
    size: "medium",
    srLabel: "Cerrar",
    role: "button",
    hierarchy: "loud",
    onClick: handleApplyFilters,
    disabled: !lengthFilters > 0
  }, void 0, button_text))));
};
FilterBottomSheet$1.defaultProps = _objectSpread$4(_objectSpread$4({}, DF_FILTER_BOTTOM_SHEET), {}, {
  onFilter: () => {}
});
var filterBottomSheet = FilterBottomSheet$1;
var _extends$1 = require$$0$3.default;
var _jsx$3 = require$$0.default;
var _objectSpread$3 = require$$0$2.default;
/* eslint-disable security/detect-object-injection */
const React$2 = require$$1;
const {
  useState: useState$1,
  useEffect
} = React$2;
const ProgressIndicatorCircular = require$$4$2;
const classNames$1 = require$$0$1;
const FilterDropdown = dropdown;
const FilterLabel = filterLabel;
const Comments = comments;
const {
  PT_FILTER,
  DF_FILTER
} = proptypes$7;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$2
} = constants$2;
const FilterBottomSheet = filterBottomSheet;
const namespace$2 = `${STYLE_NAMESPACE$2}-filter`;
const Filter$1 = _ref => {
  let {
    button_sheet_title,
    button_text,
    clean_filters,
    filterOptionsVpp,
    inline_official_store_filter,
    internal_title,
    islogged,
    levels,
    message,
    mobile,
    official_store_filter,
    onCleanFilters,
    onClickCarouselImage,
    onDenounceClick,
    onDislikeComment,
    onFilterClick,
    onLikeComment,
    order_by,
    qualification,
    reviews,
    title,
    total_opinions,
    vpp,
    summary,
    onLikeSummary,
    onDislikeSummary,
    title_reviews,
    should_hide_button_all_reviews,
    total_comments,
    empty_messages
  } = _ref;
  const [reviewsData, setReviewsData] = useState$1(reviews);
  const [currMessage, setMessage] = useState$1(message);
  const [offset, setOffset] = useState$1(15);
  const [isFetching, setFetching] = useState$1(false);
  const [isTotalOpinions, setTotalOpinions] = useState$1(total_opinions);
  const [filterOptions, setfilterOptions] = useState$1({
    rating: (filterOptionsVpp === null || filterOptionsVpp === void 0 ? void 0 : filterOptionsVpp.rating) || null,
    orderCriteria: (filterOptionsVpp === null || filterOptionsVpp === void 0 ? void 0 : filterOptionsVpp.orderCriteria) || null,
    officialStore: (filterOptionsVpp === null || filterOptionsVpp === void 0 ? void 0 : filterOptionsVpp.officialStore) || null
  });
  useEffect(() => {
    setReviewsData([...reviews]);
  }, [reviews]);
  const handleOffset = () => {
    setOffset(prevOffset => prevOffset + 15);
  };
  const handleFilter = async (filterValues, track) => {
    const response = await onFilterClick(filterValues, track);
    if (response) {
      setReviewsData(response.reviews);
      setMessage(response.message);
    }
    setFetching(false);
  };
  const calculateTotalOpinions = itemFilters => {
    const regexNumberValues = /(\d+)/g;
    const getNumber = total_opinions.match(regexNumberValues);
    let totalOpinionsLabelFilter = '';
    if (itemFilters.rating && itemFilters.rating !== 'all') {
      const LevelsPosition = 5 - Number(itemFilters.rating);
      totalOpinionsLabelFilter = getNumber && getNumber.length > 0 && levels.length > 0 ? total_opinions.replace(getNumber[0], levels[LevelsPosition].value) : total_opinions;
    } else {
      totalOpinionsLabelFilter = total_opinions;
    }
    setTotalOpinions(totalOpinionsLabelFilter);
  };
  const handlerFilterDesktop = async (value, keyObject, track) => {
    const filterValues = _objectSpread$3(_objectSpread$3({}, filterOptions), {}, {
      [keyObject]: value === 'all' ? null : value
    });
    if (!vpp) {
      setOffset(15);
      setfilterOptions(filterValues);
      calculateTotalOpinions(filterValues);
    }
    handleFilter(filterValues, track);
  };
  const handlerFilterMobile = async (itemFilters, track) => {
    if (!vpp) {
      setOffset(15);
      setfilterOptions(itemFilters);
      calculateTotalOpinions(itemFilters);
    }
    handleFilter(itemFilters, track);
  };
  const handlerCleanFilter = () => {
    const reviewsFromInitialState = onCleanFilters();
    setTotalOpinions(total_opinions);
    setReviewsData(reviewsFromInitialState);
  };
  return /*#__PURE__*/_jsx$3("div", {
    className: namespace$2,
    "data-testid": "filter-component"
  }, void 0, total_comments !== 0 && /*#__PURE__*/React$2.createElement(React$2.Fragment, null, !mobile && order_by && qualification && !should_hide_button_all_reviews && /*#__PURE__*/_jsx$3("div", {
    className: `${namespace$2}__desktop-filters`
  }, void 0, /*#__PURE__*/_jsx$3(FilterDropdown, {
    label: order_by.title,
    items: order_by.items,
    onFilter: handlerFilterDesktop,
    itemValueVpp: filterOptions.orderCriteria,
    keyObject: "orderCriteria",
    vpp: vpp
  }), /*#__PURE__*/_jsx$3(FilterDropdown, {
    label: qualification.title,
    items: qualification.items,
    itemValueVpp: filterOptions.rating,
    keyObject: "rating",
    starts: true,
    onFilter: handlerFilterDesktop,
    vpp: vpp
  }), official_store_filter && /*#__PURE__*/React$2.createElement(FilterLabel, _extends$1({}, official_store_filter, {
    itemValueVpp: !!filterOptions.officialStore,
    keyObject: "officialStore",
    onFilter: handlerFilterDesktop,
    vpp: vpp
  }))), mobile && button_text && /*#__PURE__*/_jsx$3(FilterBottomSheet, {
    qualification: qualification,
    total_opinions: isTotalOpinions,
    order_by: order_by,
    official_store_filter: official_store_filter,
    title: title,
    button_sheet_title: button_sheet_title,
    onFilter: handlerFilterMobile,
    button_text: button_text,
    internal_title: internal_title,
    clean_filters: clean_filters,
    itemValueVpp: filterOptions,
    vpp: vpp,
    onCleanFilters: handlerCleanFilter,
    title_reviews: title_reviews,
    should_hide_button_all_reviews: should_hide_button_all_reviews,
    inline_official_store_filter: inline_official_store_filter
  })), /*#__PURE__*/_jsx$3("div", {
    className: classNames$1(`${namespace$2}__comments`, {
      [`${namespace$2}__comments--mb-0`]: reviews.length === 0
    })
  }, void 0, !isFetching && /*#__PURE__*/_jsx$3(Comments, {
    reviews: reviewsData,
    islogged: islogged,
    orderCriteria: filterOptions.orderCriteria,
    rating: filterOptions.rating,
    officialStore: filterOptions.officialStore,
    message: currMessage,
    offset: offset,
    mobile: mobile,
    OnOffset: handleOffset,
    onScrollTab: onFilterClick,
    onLikeComment: onLikeComment,
    onDislikeComment: onDislikeComment,
    onDenounceClick: onDenounceClick,
    vpp: vpp,
    onClickCarouselImage: onClickCarouselImage,
    summary: summary && summary,
    onLikeSummary: summary && onLikeSummary,
    onDislikeSummary: summary && onDislikeSummary,
    title_reviews: title_reviews,
    total_comments: total_comments,
    empty_messages: empty_messages,
    total_opinions: isTotalOpinions
  })), isFetching && /*#__PURE__*/_jsx$3(ProgressIndicatorCircular, {
    "data-testid": "spinner",
    modifier: "inline",
    className: `${namespace$2}__spinner-tab`,
    size: "small"
  }));
};
Filter$1.defaultProps = _objectSpread$3({}, DF_FILTER);
var filter = Filter$1;
const {
  arrayOf: arrayOf$1,
  bool: bool$1,
  number: number$1,
  shape: shape$1,
  string: string$1
} = require$$2;
const PT_FAE$1 = shape$1({
  histogram: arrayOf$1(shape$1({
    name: string$1,
    percentage: number$1,
    value: number$1
  })),
  mobile: bool$1,
  text: string$1
});
const DF_FAE$1 = {
  histogram: [],
  mobile: true,
  text: ''
};
const PT_LEVELS$1 = {
  categories: arrayOf$1(shape$1({
    name: string$1,
    percentage: number$1,
    value: number$1
  })),
  namespace: string$1
};
const DF_LEVELS$1 = {
  categories: [],
  namespace: ''
};
var proptypes = {
  PT_FAE: PT_FAE$1,
  DF_FAE: DF_FAE$1,
  PT_LEVELS: PT_LEVELS$1,
  DF_LEVELS: DF_LEVELS$1
};
var _objectSpread$2 = require$$0$2.default;
var _jsx$2 = require$$0.default;
const {
  PT_LEVELS,
  DF_LEVELS
} = proptypes;
const ProgressBar = progressBar;
const Levels$1 = _ref => {
  let {
    categories,
    namespace
  } = _ref;
  return /*#__PURE__*/_jsx$2("ul", {
    "arial-label": "Score Categories"
  }, void 0, categories.map((_ref2, index) => {
    let {
      name,
      value,
      percentage
    } = _ref2;
    return /*#__PURE__*/_jsx$2("li", {
      className: `${namespace}__progress-bar-list`
    }, `${namespace}__level-${index}`, /*#__PURE__*/_jsx$2("div", {}, void 0, /*#__PURE__*/_jsx$2("span", {}, void 0, name)), /*#__PURE__*/_jsx$2("div", {
      "aria-hidden": "true",
      className: `${namespace}__progress-bar-container`
    }, void 0, /*#__PURE__*/_jsx$2(ProgressBar, {
      className: `${namespace}__progress-bar`,
      percentage: percentage
    })), /*#__PURE__*/_jsx$2("div", {
      className: `${namespace}__value-container`
    }, void 0, /*#__PURE__*/_jsx$2("span", {}, void 0, value)));
  }));
};
Levels$1.defaultProps = _objectSpread$2({}, DF_LEVELS);
var levels = Levels$1;
var _objectSpread$1 = require$$0$2.default;
var _jsx$1 = require$$0.default;
var _Close$1;
const React$1 = require$$1;
const {
  useState
} = React$1;
const BottomSheet = require$$3$1;
const Button$1 = require$$3;
const classnames = require$$0$1;
const Chevron = chevron;
const Close$1 = close;
const Levels = levels;
const {
  PT_FAE,
  DF_FAE
} = proptypes;
const {
  STYLE_NAMESPACE: STYLE_NAMESPACE$1
} = constants$2;
const namespace$1 = `${STYLE_NAMESPACE$1}-fae`;
const Fae$1 = _ref => {
  let {
    histogram,
    mobile,
    text
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  const calInitialHeight = 75 + histogram.length * 19;
  return /*#__PURE__*/_jsx$1("div", {
    className: namespace$1,
    "data-testid": "fae-component"
  }, void 0, /*#__PURE__*/_jsx$1("button", {
    onClick: handleClick,
    "data-testid": "fae-button"
  }, void 0, text, /*#__PURE__*/_jsx$1(Chevron, {
    className: classnames(`${namespace$1}__chevron`, {
      active: isOpen && !mobile
    })
  })), mobile ? /*#__PURE__*/_jsx$1(BottomSheet, {
    open: isOpen,
    initialHeight: `${calInitialHeight}px`
  }, void 0, /*#__PURE__*/_jsx$1("div", {
    className: `${namespace$1}--mobile`
  }, void 0, /*#__PURE__*/_jsx$1(Levels, {
    namespace: namespace$1,
    categories: histogram
  }))) : /*#__PURE__*/_jsx$1("div", {
    className: classnames(`${namespace$1}--desktop`, {
      show: isOpen
    })
  }, void 0, /*#__PURE__*/_jsx$1("div", {
    className: `${namespace$1}_triangle`
  }), /*#__PURE__*/_jsx$1("div", {
    className: `${namespace$1}_container-close`
  }, void 0, /*#__PURE__*/_jsx$1(Button$1, {
    "data-testid": "close",
    className: `${namespace$1}_close-wrapper`,
    size: "medium",
    srLabel: "Cerrar",
    role: "button",
    hierarchy: "transparent",
    onClick: handleClick
  }, void 0, _Close$1 || (_Close$1 = /*#__PURE__*/_jsx$1(Close$1, {})))), /*#__PURE__*/_jsx$1(Levels, {
    namespace: namespace$1,
    categories: histogram
  })));
};
Fae$1.defaultProps = _objectSpread$1({}, DF_FAE);
var fae = Fae$1;
const {
  arrayOf,
  func,
  number,
  shape,
  string,
  bool
} = require$$2;
const PT_TRACK = track;
const PT_REVIEWS_DESKTOP$1 = {
  attributes: shape({
    close_see_more: string,
    items: arrayOf(shape({
      name: string,
      value: number
    })),
    mobile: bool,
    show_see_more: string,
    title: string
  }),
  buy_button: shape({
    levels: arrayOf(shape({}))
  }),
  carousel: shape(),
  className: string,
  embedded: bool,
  filter: shape({
    buton_text: string,
    qualification: shape({
      items: arrayOf(shape({
        text: string,
        value: string
      })),
      title: string
    }),
    order_by: shape({
      items: arrayOf(shape({
        text: string,
        value: string
      })),
      title: string
    })
  }),
  filterOptionsVpp: shape({
    orderCriteria: string,
    rating: string
  }),
  islogged: bool,
  message: shape({
    subtitle: string,
    title: string,
    type: string
  }),
  onBuyClick: func,
  onClickCarouselImage: func.isRequired,
  onDenounceClick: func.isRequired,
  onDislikeComment: func.isRequired,
  onFilter: func,
  onLikeComment: func.isRequired,
  onScrollTab: func,
  onSeeMoreClick: func,
  quali_attributes: arrayOf(shape({
    histogram: arrayOf(shape({
      name: string,
      percentage: number,
      value: number
    })),
    mobile: bool,
    text: string
  })),
  rating: shape({
    levels: arrayOf(shape({}))
  }),
  reviews: arrayOf(shape({
    content: string,
    dislikes: number,
    id: number.isRequired,
    likes: number,
    rate: number,
    title: shape({
      text: string
    }),
    version: shape({
      text: string
    })
  })).isRequired,
  see_more: shape({
    text: string,
    track: PT_TRACK,
    url: string
  }),
  title: shape({
    info: shape({}),
    text: string
  }),
  vpp: bool,
  runCatchErrorBoundary: func
};
const DF_REVIEWS_DESKTOP$1 = {
  attributes: {},
  buy_button: null,
  className: null,
  embedded: false,
  filter: {},
  onBuyClick: func,
  rating: {},
  title: {},
  vpp: false,
  runCatchErrorBoundary: () => {}
};
const PT_REVIEWS_MOBILE = {
  attributes: shape({
    close_see_more: string,
    items: arrayOf(shape({
      name: string,
      value: number
    })),
    mobile: bool,
    show_see_more: string,
    title: string
  }),
  buy_button: shape({
    levels: arrayOf(shape({}))
  }),
  carousel: shape(),
  embedded: bool,
  filter: shape({
    buton_text: string,
    official_store_filter: shape({
      title: shape({
        text: string
      }),
      track: PT_TRACK,
      value: bool
    }),
    qualification: shape({
      items: arrayOf(shape({
        text: string,
        value: string
      })),
      title: string
    }),
    order_by: shape({
      items: arrayOf(shape({
        text: string,
        value: string
      })),
      title: string
    })
  }),
  filterOptionsVpp: shape({
    orderCriteria: string,
    rating: string
  }),
  inline_official_store_filter: shape({
    title: shape({
      text: string
    }),
    track: PT_TRACK,
    value: bool
  }),
  islogged: bool,
  message: shape({
    subtitle: string,
    title: string,
    type: string
  }),
  onBuyClick: func,
  onCleanFilters: func,
  onClickCarouselImage: func,
  onDenounceClick: func,
  onDislikeComment: func,
  onFilter: func,
  onLikeComment: func,
  onScrollTab: func,
  onSeeMoreClick: func,
  quali_attributes: arrayOf(shape({
    histogram: arrayOf(shape({
      name: string,
      percentage: number,
      value: number
    })),
    mobile: bool,
    text: string
  })),
  rating: shape({
    levels: arrayOf(shape({}))
  }),
  reviews: arrayOf(shape({
    content: string,
    dislikes: number,
    id: number.isRequired,
    likes: number,
    rate: number,
    title: shape({
      text: string
    }),
    version: shape({
      text: string
    })
  })).isRequired,
  see_more: shape({
    text: string,
    track: PT_TRACK,
    url: string
  }),
  showAllButton: shape({
    text: string,
    track: PT_TRACK,
    url: string
  }),
  title: shape({
    info: shape({}),
    text: string
  }),
  total_opinions: string,
  vpp: bool,
  webview: bool,
  runCatchErrorBoundary: func
};
const DF_REVIEWS_MOBILE = {
  attributes: {},
  embedded: false,
  inline_official_store_filter: null,
  rating: {},
  title: {},
  vpp: false,
  webview: false,
  runCatchErrorBoundary: () => {}
};
var reviewsProptypes = {
  PT_REVIEWS_DESKTOP: PT_REVIEWS_DESKTOP$1,
  DF_REVIEWS_DESKTOP: DF_REVIEWS_DESKTOP$1,
  PT_REVIEWS_MOBILE,
  DF_REVIEWS_MOBILE
};
var _extends = require$$0$3.default;
var _jsx = require$$0.default;
var _objectSpread = require$$0$2.default;
var _Info, _Close;
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable nordic/i18n-jsx-no-literals */
/* eslint-disable no-mixed-operators */
const React = require$$1;
const classNames = require$$0$1;
const Button = require$$3;
const Tooltip = require$$9;
const Rating = rating;
const RatingLevels = ratingLevels;
const BuyButton = buyButton;
const Categories = categories;
const Filter = filter;
const Fae = fae;
const Info = info;
const Close = close;
const Carousel = carousel;
const Summary = summary;
const {
  PT_REVIEWS_DESKTOP,
  DF_REVIEWS_DESKTOP
} = reviewsProptypes;
const {
  STYLE_NAMESPACE,
  KIT_DEFAULT_VALUE
} = constants$2;
const namespace = STYLE_NAMESPACE;
const Reviews = _ref => {
  let {
    attributes,
    buy_button,
    carousel,
    className,
    embedded,
    filter,
    filterOptionsVpp,
    islogged,
    message,
    onBuyClick,
    onClickCarouselImage,
    onDenounceClick,
    onDislikeComment,
    onFilter,
    onLikeComment,
    onLikeSummary,
    onDislikeSummary,
    onScrollTab,
    onSeeMoreClick,
    quali_attributes,
    rating,
    reviews,
    see_more,
    see_more: {
      should_hide_button_all_reviews
    },
    summary,
    title,
    title_reviews,
    vpp,
    reviews_with_comment,
    empty_messages,
    total_opinions,
    runCatchErrorBoundary,
    object_type
  } = _ref;
  try {
    var _title$info, _faeData$histogram, _attributes$items;
    const isKit = object_type && object_type === KIT_DEFAULT_VALUE;
    const handleClickClose = e => {
      e.preventDefault();
      window.parent.postMessage('close=', '*');
    };
    const handleSeeMoreClick = () => {
      onSeeMoreClick(see_more.url, see_more.track);
    };
    const faeData = quali_attributes === null || quali_attributes === void 0 ? void 0 : quali_attributes.find(att => att.id === 'fae');
    const carouselProps = carousel ? _objectSpread(_objectSpread({}, carousel), {}, {
      preload: !vpp,
      lazyload: vpp
    }) : carousel;
    const total_comments = reviews_with_comment || reviews.length;
    return /*#__PURE__*/_jsx("section", {
      "data-testid": "reviews-desktop",
      className: classNames(`${namespace}-main`, {
        [`${namespace}__container-vpp`]: vpp
      }, {
        className: !!className
      })
    }, void 0, /*#__PURE__*/_jsx("header", {
      className: !vpp ? classNames(`${namespace}__header`) : classNames(`${namespace}__header--vpp`)
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__container`
    }, void 0, /*#__PURE__*/_jsx("h2", {
      className: `${namespace}__header__title`
    }, void 0, title.text), !vpp && /*#__PURE__*/_jsx(Tooltip, {
      content: (_title$info = title.info) === null || _title$info === void 0 ? void 0 : _title$info.subtitle,
      title: title.info.title,
      side: "bottom"
    }, void 0, _Info || (_Info = /*#__PURE__*/_jsx(Info, {})))), !embedded && /*#__PURE__*/_jsx(Button, {
      "data-testid": "close",
      className: `${namespace}__close-wrapper`,
      size: "medium",
      srLabel: "Cerrar",
      role: "button",
      hierarchy: "transparent",
      onClick: handleClickClose
    }, void 0, _Close || (_Close = /*#__PURE__*/_jsx(Close, {})))), /*#__PURE__*/_jsx("div", {
      className: `${namespace}`
    }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, rating && /*#__PURE__*/React.createElement(Rating, _extends({}, rating, {
      mobile: false,
      isKitLayout: isKit
    }), rating.levels && /*#__PURE__*/_jsx(RatingLevels, {
      levels: rating.levels
    })), !isKit && /*#__PURE__*/React.createElement(React.Fragment, null, vpp && buy_button && /*#__PURE__*/_jsx(BuyButton, {
      buy_button: buy_button,
      onBuyClick: onBuyClick
    }), faeData && (faeData === null || faeData === void 0 || (_faeData$histogram = faeData.histogram) === null || _faeData$histogram === void 0 ? void 0 : _faeData$histogram.length) > 0 && /*#__PURE__*/React.createElement(Fae, _extends({}, faeData, {
      mobile: false
    })), (attributes === null || attributes === void 0 ? void 0 : attributes.items) && (attributes === null || attributes === void 0 || (_attributes$items = attributes.items) === null || _attributes$items === void 0 ? void 0 : _attributes$items.length) > 0 && /*#__PURE__*/React.createElement(Categories, _extends({}, attributes, {
      mobile: false,
      vpp: vpp,
      onSeeMoreClick: handleSeeMoreClick,
      total_comments: total_comments
    })))), /*#__PURE__*/_jsx("div", {}, void 0, reviews && summary && summary.components[0].id !== 'SUMMARY' && /*#__PURE__*/React.createElement(Summary, _extends({
      onLikeSummary: onLikeSummary,
      onDislikeSummary: onDislikeSummary,
      islogged: islogged
    }, summary)), reviews && carousel && /*#__PURE__*/_jsx("div", {
      className: `${namespace}__reviews-carousel`
    }, void 0, /*#__PURE__*/_jsx("h3", {
      className: `${namespace}__reviews-carousel__title`
    }, void 0, carousel.title.text), /*#__PURE__*/React.createElement(Carousel, _extends({}, carouselProps, {
      onClickImage: onClickCarouselImage
    }))), reviews && /*#__PURE__*/React.createElement(Filter, _extends({}, filter, {
      filterOptionsVpp: filterOptionsVpp,
      onFilterClick: onFilter,
      reviews: reviews,
      onScrollTab: onScrollTab,
      onLikeComment: onLikeComment,
      onDislikeComment: onDislikeComment,
      onDenounceClick: onDenounceClick,
      islogged: islogged,
      mobile: false,
      vpp: vpp,
      onClickCarouselImage: onClickCarouselImage,
      message: message,
      summary: summary && summary.components[0].id === 'SUMMARY' ? summary : null,
      onLikeSummary: summary && summary.components[0].id === 'SUMMARY' ? onLikeSummary : null,
      onDislikeSummary: summary && summary.components[0].id === 'SUMMARY' ? onDislikeSummary : null,
      title_reviews: title_reviews,
      should_hide_button_all_reviews: should_hide_button_all_reviews,
      total_comments: total_comments,
      empty_messages: empty_messages,
      total_opinions: total_opinions
    })), see_more && vpp && /*#__PURE__*/_jsx("div", {}, void 0, !should_hide_button_all_reviews && reviews_with_comment !== 0 && /*#__PURE__*/_jsx("button", {
      "data-testid": "see-more",
      size: "medium",
      "aria-label": "Cerrar",
      role: "button",
      hierarchy: "transparent",
      className: "show-more-click",
      onClick: handleSeeMoreClick
    }, void 0, see_more.text)))));
  } catch (error) {
    return runCatchErrorBoundary(error);
  }
};
Reviews.defaultProps = _objectSpread({}, DF_REVIEWS_DESKTOP);
var reviews_desktop = Reviews;
const ReviewsDesktop = reviews_desktop;

/**
 * ReviewsDesktop as named export
 */

var ReviewsDesktopCapability = reviews_desktop$1.ReviewsDesktopCapability = ReviewsDesktop;
exports.ReviewsDesktopCapability = ReviewsDesktopCapability;
exports.default = reviews_desktop$1;
